// Drone tiles come from the shared EstateMap module (modules/map.js) — used lazily
// inside the map-build handler below (EstateMap is defined by the time that runs).

$(document).on('click', '.create-task', function () {
    $.ajax({
        url: '/api/task/template/modal',
        method: 'GET'
    }).done(function (response) {
        const main_dialog = new Dialog("Select Task Template", response.html, { size: '2xl' });
        main_dialog.setButtons([
            {
                name: "Cancel",
                dismiss: true,
            }
        ]);
        main_dialog.show();
        $('.template-card').on('click', function () {
            const templateId = $(this).data('id');
            if (!templateId) {
                Toast.show("Template ID not found.", "error", 3000);
                return;
            }
            main_dialog.hide();
            $.ajax({
                url: '/api/task/create',
                method: 'GET',
                data: {
                    template_id: templateId
                }
            }).done(function (response) {
                const dialog = new Dialog("Create Task", response.html, { size: '2xl' });
                dialog.setButtons([
                    {
                        name: "Cancel",
                        dismiss: true,
                    },
                    {
                        name: "Create",
                        class: "bg-green-600 text-white hover:bg-green-700 create-task-btn",
                        onClick: function () {
                            const btn = $(this);
                            const loadingBtn = new LoadingButton(btn);
                            loadingBtn.start();
                            const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                            const form = $('#createTaskForm');
                            const name = $('#m-name').val();
                            const taskType = $('#m-task-type').val();
                            const templateId = form.data('id');
                            const blockId = $('#m-block').val();
                            const subBlockId = $('#m-sub-block-id').val() || null;
                            // Collect every selected worker chip, or use the stored all-worker IDs.
                            const allChk = $('#m-allWorkersChk');
                            const isAllWorkers = allChk.is(':checked');
                            // "All Workers" is an open task — send only the flag; the backend
                            // stores no individual assignments (who does it is captured at entry).
                            const userIds = isAllWorkers
                                ? []
                                : $('#m-selectedUsers .user-chip').map(function () {
                                    return $(this).data('user-id');
                                }).get();
                            const startDate = $('#m-startDate').val();
                            const dueDate = $('#m-dueDate').val();
                            const reminderDate = $('#m-reminderDate').val();
                            const recurrence = $('#m-recurrence').val();
                            const description = $('#m-taskDescription').val();

                            if (!templateId) {
                                Toast.show("Template ID not found.", "error", 3000);
                                loadingBtn.stop();
                                return;
                            }

                            if (taskType === 'assign_task') {
                                if (!blockId) {
                                    Toast.show("Please select a block.", "error", 3000);
                                    loadingBtn.stop();
                                    return;
                                }
                                if (!isAllWorkers && userIds.length === 0) {
                                    Toast.show("Please add at least one worker.", "error", 3000);
                                    loadingBtn.stop();
                                    return;
                                }
                                if (!startDate || !dueDate) {
                                    Toast.show("Please set a start and due date.", "error", 3000);
                                    loadingBtn.stop();
                                    return;
                                }
                            } else if (!reminderDate) {
                                Toast.show("Please set a reminder date.", "error", 3000);
                                loadingBtn.stop();
                                return;
                            }

                            // local time to UTC
                            const startDateUTC = startDate ? new Date(startDate).toISOString() : null;
                            const dueDateUTC = dueDate ? new Date(dueDate).toISOString() : null;
                            const reminderDateUTC = reminderDate ? new Date(reminderDate).toISOString() : null;

                            $.ajax({
                                url: '/api/task/create',
                                method: 'POST',
                                headers: {
                                    'X-CSRFToken': csrftoken
                                },
                                data: {
                                    name: name,
                                    task_type: taskType,
                                    template_id: templateId,
                                    block_id: taskType === 'assign_task' ? blockId : null,
                                    sub_block_id: taskType === 'assign_task' ? subBlockId : null,
                                    user_ids: JSON.stringify(taskType === 'assign_task' ? userIds : []),
                                    all_workers: isAllWorkers ? '1' : '',
                                    start_at: startDateUTC,
                                    due_at: dueDateUTC,
                                    remind_at: reminderDateUTC,
                                    recurrence: recurrence,
                                    description: description
                                }
                            }).done(function (response) {
                                Toast.show("Task created successfully.", "success", 3000);
                                dialog.hide();
                                setTimeout(function () {
                                    window.location.reload();
                                }, 100);
                            }).fail(function (error) {
                                Toast.show(error.responseJSON?.error || "Failed to create task.", "error", 3000);
                            }).always(function () {
                                loadingBtn.stop();
                            });

                        }
                    }
                ]);
                dialog.show();

                // ── Sub-block mini-map ───────────────────────────────────────
                // Sub-block section palette (matches blocks.js)
                const TASK_SECTION_PALETTE = ['#ef4444', '#f59e0b', '#22c55e', '#0ea5e9', '#a855f7', '#ec4899', '#14b8a6', '#eab308', '#3b82f6', '#f97316', '#84cc16', '#06b6d4', '#d946ef', '#10b981', '#f43f5e', '#8b5cf6', '#fbbf24', '#f87171', '#34d399', '#60a5fa', '#c084fc', '#fb923c', '#4ade80', '#22d3ee', '#e879f9'];
                let taskSubMap = null;        // Leaflet map instance inside the modal
                let taskSubLayers = {};       // sub_id -> leaflet layer
                let taskSubData = null;       // current FeatureCollection

                function destroyTaskSubMap() {
                    if (taskSubMap) { taskSubMap.remove(); taskSubMap = null; }
                    taskSubLayers = {};
                    taskSubData = null;
                }

                function selectSubBlock(id, name) {
                    // Update hidden field
                    $('#m-sub-block-id').val(id);
                    // Update badge
                    $('#m-subblock-selected-name').text(name);
                    $('#m-subblock-selected-badge').removeClass('hidden').addClass('flex');
                    // Highlight selected layer, dim others + fly-to selected sub-block
                    if (taskSubData && taskSubMap) {
                        taskSubData.features.forEach(function (f, i) {
                            const fId = f.properties.id || f.id;
                            const lyr = taskSubLayers[fId];
                            if (!lyr) return;
                            if (fId === id) {
                                lyr.setStyle({ weight: 4, color: '#0f172a', fillOpacity: 0.65, opacity: 1 });
                                lyr.bringToFront();
                                // Fly map to centre of selected sub-block
                                const bounds = lyr.getBounds();
                                if (bounds && bounds.isValid()) {
                                    taskSubMap.flyToBounds(bounds, {
                                        padding: [30, 30],
                                        duration: 0.5,
                                        easeLinearity: 0.25,
                                        maxZoom: 19
                                    });
                                }
                            } else {
                                lyr.setStyle({ weight: 1.5, color: '#ffffff', fillOpacity: 0.25, opacity: 0.6 });
                            }
                        });
                    }
                    // Update chip styles
                    $('#m-subblock-list .sub-chip').each(function () {
                        if ($(this).data('sub-id') === id) {
                            $(this).addClass('!bg-emerald-600 !text-white !border-emerald-600');
                        } else {
                            $(this).removeClass('!bg-emerald-600 !text-white !border-emerald-600');
                        }
                    });
                }

                function loadSubBlocks(blockId) {
                    // Reset sub-block selection
                    $('#m-sub-block-id').val('');
                    $('#m-subblock-selected-badge').addClass('hidden').removeClass('flex');
                    // Show panel in loading state
                    $('#m-subblock-panel').removeClass('hidden');
                    $('#m-subblock-loading').removeClass('hidden');
                    $('#m-subblock-empty').addClass('hidden');
                    $('#m-subblock-content').addClass('hidden');
                    destroyTaskSubMap();

                    $.get('/api/block/section/list', { block_id: blockId }).done(function (fc) {
                        $('#m-subblock-loading').addClass('hidden');
                        if (!fc || !fc.features || fc.features.length === 0) {
                            $('#m-subblock-empty').removeClass('hidden');
                            return;
                        }
                        taskSubData = fc;
                        $('#m-subblock-count').text(`(${fc.features.length} sub-blocks)`);
                        $('#m-subblock-content').removeClass('hidden');

                        // Build Leaflet mini-map (lazy-load Leaflet if not present)
                        function initMiniMap() {
                            const container = document.getElementById('m-subblock-map');
                            if (!container) return;

                            // Use canvas renderer for much smoother GeoJSON rendering
                            const canvasRenderer = L.canvas({ padding: 0.5, tolerance: 5 });

                            taskSubMap = L.map(container, {
                                zoomControl: true,
                                scrollWheelZoom: false,   // enabled on focus (see below)
                                attributionControl: false,
                                maxZoom: 21,
                                zoomAnimation: true,
                                markerZoomAnimation: true,
                                preferCanvas: true,
                                renderer: canvasRenderer,
                            });

                            // Enable scroll wheel zoom only while the map is focused/hovered,
                            // preventing accidental page scrolling when scrolling past the map.
                            container.addEventListener('mouseenter', function () {
                                taskSubMap.scrollWheelZoom.enable();
                            });
                            container.addEventListener('mouseleave', function () {
                                taskSubMap.scrollWheelZoom.disable();
                            });

                            // Drone-ortho + satellite basemap from the shared EstateMap module.
                            EstateMap.addBasemap(taskSubMap).then(function () {
                                // Ensure subblock layers stay on top of tile layers
                                Object.values(taskSubLayers).forEach(function (lyr) { lyr.bringToFront(); });
                            });

                            let bounds = null;
                            fc.features.forEach(function (feat, idx) {
                                const subId = feat.properties.id || feat.id;
                                const color = TASK_SECTION_PALETTE[idx % TASK_SECTION_PALETTE.length];
                                const lyr = L.geoJSON(feat, {
                                    renderer: canvasRenderer,
                                    style: { color: '#ffffff', weight: 1.5, fillColor: color, fillOpacity: 0.45, opacity: 0.95 },
                                    onEachFeature: function (f, l) {
                                        const pr = f.properties || {};
                                        const palms = pr.palm_count != null ? ` · 🌴 ${pr.palm_count}` : '';
                                        l.bindTooltip(
                                            `<strong>${pr.name || subId}</strong><br>${pr.area_ha != null ? pr.area_ha + ' ha' : ''}${palms}`,
                                            { sticky: true, direction: 'top', offset: [0, -4] }
                                        );
                                        l.on('click', function () { selectSubBlock(subId, pr.name || subId); });

                                        l.on('mouseover', function () {
                                            const isSelected = String($('#m-sub-block-id').val()) === String(subId);
                                            if (!isSelected) {
                                                this.setStyle({ weight: 2.5, color: '#60a5fa', fillOpacity: 0.65 });
                                                this.bringToFront();
                                            }
                                        });
                                        l.on('mouseout', function () {
                                            const isSelected = String($('#m-sub-block-id').val()) === String(subId);
                                            if (!isSelected) {
                                                this.setStyle({ weight: 1.5, color: '#ffffff', fillOpacity: 0.45 });
                                            }
                                        });
                                    }
                                }).addTo(taskSubMap);
                                taskSubLayers[subId] = lyr;
                                const b = lyr.getBounds();
                                bounds = bounds ? bounds.extend(b) : b;
                            });

                            if (bounds && bounds.isValid()) {
                                taskSubMap.fitBounds(bounds, { padding: [20, 20], animate: true, duration: 0.5 });
                            }
                            // Force resize after modal open animation completes
                            setTimeout(function () { taskSubMap.invalidateSize({ animate: false }); }, 300);
                            setTimeout(function () { taskSubMap.invalidateSize({ animate: false }); }, 700);
                        }

                        // Leaflet may already be loaded (blocks page) or loaded via custom_js
                        if (typeof L !== 'undefined') {
                            initMiniMap();
                        } else {
                            // Dynamically load Leaflet CSS + JS if not present
                            if (!document.getElementById('leaflet-css-modal')) {
                                const css = document.createElement('link');
                                css.id = 'leaflet-css-modal';
                                css.rel = 'stylesheet';
                                css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
                                document.head.appendChild(css);
                            }
                            if (!document.getElementById('leaflet-js-modal')) {
                                const s = document.createElement('script');
                                s.id = 'leaflet-js-modal';
                                s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
                                s.onload = initMiniMap;
                                document.head.appendChild(s);
                            } else {
                                initMiniMap();
                            }
                        }

                        // Build chip list
                        const $list = $('#m-subblock-list').empty();
                        fc.features.forEach(function (feat, idx) {
                            const subId = feat.properties.id || feat.id;
                            const name = feat.properties.name || subId;
                            const color = TASK_SECTION_PALETTE[idx % TASK_SECTION_PALETTE.length];
                            const chip = $(`<button type="button" class="sub-chip inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium cursor-pointer transition-all" data-sub-id="${subId}" data-sub-name="${name}" style="border-color:${color};color:${color}">
                                <span class="inline-block w-2 h-2 rounded-full flex-shrink-0" style="background:${color}"></span>
                                ${name}
                            </button>`);
                            chip.on('click', function () { selectSubBlock(subId, name); });
                            $list.append(chip);
                        });

                    }).fail(function () {
                        $('#m-subblock-loading').addClass('hidden');
                        $('#m-subblock-empty').removeClass('hidden');
                    });
                }

                // Wire block select change → load sub-blocks
                $('#m-block').off('change.subblock').on('change.subblock', function () {
                    const blockId = $(this).val();
                    if (blockId) loadSubBlocks(blockId);
                });

                // Clean up map when dialog closes
                dialog.onHide = function () { destroyTaskSubMap(); };
                // ── End sub-block mini-map ───────────────────────────────────

                // ── Assign vs Reminder mode toggle ──────────────────────────
                $('#m-mode-toggle .m-mode-btn').on('click', function () {
                    const mode = $(this).data('mode');
                    $('#m-task-type').val(mode);
                    $('#m-mode-toggle .m-mode-btn')
                        .removeClass('bg-green-600 text-white')
                        .addClass('bg-white text-slate-600');
                    $(this).removeClass('bg-white text-slate-600').addClass('bg-green-600 text-white');
                    $('.m-section').each(function () {
                        $(this).toggleClass('hidden', $(this).data('section') !== mode);
                    });
                });

                // ── Multi-worker chip selection ─────────────────────────────
                const userSearchInput = $('#m-userSearch');
                const userDropdown = $('#m-userDropdown');
                const userSearchLoading = $('#m-userSearchLoading');
                let searchTimeout = null;

                function addWorkerChip(user) {
                    const name = `${user.first_name || ''} ${user.last_name || ''}`.trim() ||
                        (user.credentials?.username || user.id);
                    if ($(`#m-selectedUsers .user-chip[data-user-id="${user.id}"]`).length) return;
                    $('#m-selectedUsers').append(
                        `<span class="user-chip inline-flex items-center gap-1.5 bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-md px-2 py-1 text-xs font-medium" data-user-id="${user.id}">
                            ${name}
                            <button type="button" class="remove-worker-chip text-emerald-600 hover:text-emerald-900"><i class="bi bi-x-lg"></i></button>
                        </span>`
                    );
                }

                // ── "All Workers" checkbox toggle ─────────────────────────
                let allWorkersActive = false;
                const allWorkersChk = $('#m-allWorkersChk');
                const workerSearchWrap = $('#m-workerSearchWrap');
                const workerSearchHint = $('#m-workerSearchHint');

                allWorkersChk.on('change', function () {
                    if (!this.checked) {
                        // Uncheck: clear the badge, re-show search
                        allWorkersActive = false;
                        $('#m-selectedUsers').empty();
                        workerSearchWrap.removeClass('hidden');
                        workerSearchHint.removeClass('hidden');
                        return;
                    }
                    // "All Workers" = the task is open to every worker. We don't assign or
                    // download individual workers — the backend stores just the flag, and who
                    // actually does it is recorded at daily-log entry time. Show only a count
                    // badge; the total is baked into the form (data-worker-count), so no fetch.
                    allWorkersActive = true;
                    workerSearchWrap.addClass('hidden');
                    workerSearchHint.addClass('hidden');
                    userDropdown.addClass('hidden');
                    const workerTotal = allWorkersChk.data('worker-count') || 0;
                    $('#m-selectedUsers').html(
                        '<span class="all-workers-badge inline-flex items-center gap-1.5 bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-md px-2 py-1 text-xs font-medium">All Workers (' + workerTotal + ')</span>'
                    );
                });

                const getSelected = () => {
                    return $('#m-selectedUsers .user-chip').map(function() {
                        return String($(this).data('user-id'));
                    }).get();
                };

                initPaginatedWorkerSearch(userSearchInput, userDropdown, userSearchLoading, function(user, isChecked) {
                    if (isChecked) {
                        addWorkerChip(user);
                    } else {
                        $('#m-selectedUsers').find(`.user-chip[data-user-id="${user.id}"]`).remove();
                        $('#m-selectedUsers').find(`.user-chip[data-user-id="${String(user.id)}"]`).remove();
                    }
                }, null, true, getSelected);
            }).fail(function (error) {
                Toast.show("Failed to load task creation form.", "error", 3000);
            });
        })
    }).fail(function (error) {
        Toast.show("Failed to load templates.", "error", 3000);
    });
});

// Remove a selected worker chip from the task-create form (individual selections only;
// "All Workers" is a single non-removable badge cleared by unchecking the box).
$(document).on('click', '.remove-worker-chip', function () {
    var $chip = $(this).closest('.user-chip');
    // Uncheck in dropdown if it's open
    const userId = $chip.data('user-id');
    if (userId) {
        $('#m-userDropdown').find(`[data-user-id="${userId}"] input[type="checkbox"]`).prop('checked', false);
    }
    $chip.remove();
});

$(document).on('click', '.task-status', function () {
    const taskId = $(this).data('id');
    if (!taskId) {
        Toast.show("Task ID not found.", "error", 3000);
        return;
    }
    const status = $(this).data('status');
    if (!status) {
        Toast.show("Task status not found.", "error", 3000);
        return;
    }

    // Build confirmation dialog content based on action type
    const isCompleted = status === 'completed';
    const dialogTitle = isCompleted ? 'Mark as Completed' : 'Cancel Task';
    const dialogMsg = isCompleted
        ? '<p>Are you sure you want to mark this task as <strong>completed</strong>? This will update the task status and cannot be easily undone.</p>'
        : '<p>Are you sure you want to <strong>cancel</strong> this task? The task will be marked as cancelled.</p>';
    const btnClass = isCompleted
        ? 'bg-green-600 text-white hover:bg-green-700'
        : 'bg-red-600 text-white hover:bg-red-700';
    const btnLabel = isCompleted ? 'Mark Completed' : 'Cancel Task';

    const dialog = new Dialog(dialogTitle, dialogMsg, { size: 'md' });
    dialog.setButtons([
        { name: 'Cancel', dismiss: true },
        {
            name: btnLabel,
            class: btnClass,
            onClick: function () {
                const btn = $(this);
                const loadingBtn = new LoadingButton(btn);
                loadingBtn.start();
                const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                $.ajax({
                    url: '/api/task/update/status',
                    method: 'POST',
                    headers: { 'X-CSRFToken': csrftoken },
                    data: { id: taskId, status: status }
                }).done(function (response) {
                    loadingBtn.stop();
                    dialog.hide();
                    Toast.show('Task marked as ' + status.toUpperCase() + '.', 'success', 3000);
                    window.location.reload();
                }).fail(function (error) {
                    loadingBtn.stop();
                    Toast.show(error.responseJSON?.error || 'Failed to update task status.', 'error', 3000);
                });
            }
        }
    ]);
    dialog.show();
});

$(document).on('click', '.task-delete', function () {
    const taskId = $(this).data('id');
    if (!taskId) {
        Toast.show("Task ID not found.", "error", 3000);
        return;
    }
    const button = $(this);
    const dialog = new Dialog(
        'Confirm Deletion',
        '<p>Are you sure you want to <strong>delete</strong> this task? This action cannot be undone.</p>',
        { size: 'md' }
    );
    dialog.setButtons([
        { name: 'Cancel', dismiss: true },
        {
            name: 'Delete',
            class: 'bg-red-600 text-white hover:bg-red-700',
            onClick: function () {
                const btn = $(this);
                const loadingBtn = new LoadingButton(btn);
                loadingBtn.start();
                const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                $.ajax({
                    url: '/api/task/delete',
                    method: 'POST',
                    headers: { 'X-CSRFToken': csrftoken },
                    data: { id: taskId }
                }).done(function (response) {
                    loadingBtn.stop();
                    dialog.hide();
                    Toast.show('Task deleted successfully.', 'success', 3000);
                    button.closest('tr').remove();
                }).fail(function (error) {
                    loadingBtn.stop();
                    Toast.show(error.responseJSON?.error || 'Failed to delete task.', 'error', 3000);
                });
            }
        }
    ]);
    dialog.show();
});

$(document).on('click', '.task-info', function () {
    const taskId = $(this).data('id');
    if (!taskId) {
        Toast.show("Task ID not found.", "error", 3000);
        return;
    }
    $.ajax({
        url: '/api/task/info',
        method: 'GET',
        data: {
            id: taskId
        }
    }).done(function (response) {
        const dialog = new Dialog("Task Information", response.html, { size: '2xl' });
        dialog.setButtons([
            {
                name: "Close",
                dismiss: true,
            }
        ]);
        dialog.show();
    }).fail(function (error) {
        Toast.show("Failed to load task information.", "error", 3000);
    });
});

// ── Daily Log (updated Manual Entry module) ─────────────────────────────────
// Opens a per-day capture form built from the task template's capture fields.
function renderDailyLogField(f) {
    const key = f.key;
    const label = f.label || key;
    const unit = f.unit ? ` <span class="text-xs text-slate-400">(${f.unit})</span>` : '';
    const req = '';
    // A "workers"-type capture field → chip-based multi-select with API search (same as Create Task)
    if (f.type === 'workers') {
        return `<div class="col-span-2 md:col-span-3 dl-workers-container" data-key="${key}" data-type="workers" data-selected-workers="[]">
            <div class="flex items-center gap-4 mb-2">
                <label class="block text-xs font-medium text-slate-600">${label}${unit}</label>
            </div>
            <div class="dl-selected-users flex flex-wrap gap-1.5 mb-2"></div>
            <div class="relative dl-worker-search-wrap">
                <input type="text" class="dl-user-search w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20" placeholder="Search workers to add…" autocomplete="off">
                <div class="dl-search-loading absolute right-3 top-1/2 -translate-y-1/2 hidden">
                    <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
                <div class="dl-user-dropdown absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg hidden max-h-60 overflow-y-auto"></div>
            </div>
            <div class="text-[11px] text-slate-400 mt-1">Selected: <span class="dl-wk-count">0</span></div>
        </div>`;
    }
    let input;
    if (f.type === 'computed') {
        const formula = (f.formula || '').replace(/"/g, '&quot;');
        input = `<input type="text" readonly class="dl-field w-full border border-slate-200 bg-slate-100 rounded-md px-3 py-2 text-sm text-slate-500" data-key="${key}" data-type="computed" data-formula="${formula}" placeholder="auto">`;
    } else if (f.type === 'time') {
        input = `<input type="time" class="dl-field w-full border border-slate-200 rounded-md px-3 py-2 text-sm text-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500/20" data-key="${key}" data-type="time">`;
    } else if (f.type === 'text') {
        input = `<input type="text" class="dl-field w-full border border-slate-200 rounded-md px-3 py-2 text-sm text-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500/20" data-key="${key}" data-type="text">`;
    } else {
        input = `<input type="number" step="any" class="dl-field w-full border border-slate-200 rounded-md px-3 py-2 text-sm text-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500/20" data-key="${key}" data-type="number" placeholder="0">`;
    }
    return `<div><label class="block text-xs font-medium text-slate-600 mb-1">${label}${unit}${req}</label>${input}</div>`;
}

// Safe arithmetic evaluator for computed-field formulas (mirrors the server).
// After substituting variable names with their numeric values, only digits,
// operators and parentheses may remain — anything else returns null.
function evalFormula(formula, vars) {
    if (!formula) return null;
    // Replace each identifier with its numeric value, or the sentinel (0/0)=NaN when
    // missing. The lookbehind avoids matching exponent suffixes (the 'e3' in 1e3).
    // After substitution NO letters survive, so the validated string IS the executed one.
    const expr = String(formula).replace(/(?<![\d.])[a-zA-Z_][a-zA-Z0-9_]*/g, function (name) {
        const v = vars[name];
        if (v === undefined || v === null || v === '' || isNaN(v)) return '(0/0)';
        return '(' + Number(v) + ')';
    });
    if (!/^[\deE.\s+\-*/()]*$/.test(expr)) return null;  // pure arithmetic only
    try {
        const r = Function('"use strict"; return (' + expr + ');')();
        return (typeof r === 'number' && isFinite(r)) ? Math.round(r * 10000) / 10000 : null;
    } catch (e) {
        return null;
    }
}

// Recompute every computed field in the Daily Log form from the current inputs.
// Multi-pass so a computed field may reference another computed field (mirrors server).
function recomputeDailyLog() {
    const vars = {};
    // A number field left blank counts as 0 (mirrors the server).
    $('#dl-fields .dl-field[data-type="number"]').each(function () {
        const v = $(this).val();
        vars[$(this).data('key')] = (v !== '' && v != null && !isNaN(v)) ? parseFloat(v) : 0;
    });
    if (dlAbw !== null) vars['abw'] = dlAbw;   // block's Average Bunch Weight for the entry's month
    // "Number of Workers" pickers contribute their selected count to computed formulas.
    $('#dl-fields .dl-workers-container').each(function () {
        const picked = $(this).data('selected-workers') || [];
        vars[$(this).data('key')] = picked.length;
    });
    const area = $('#dl-area').val();
    if (area !== '' && area != null && !isNaN(area)) vars['area'] = parseFloat(area);
    const $computed = $('#dl-fields .dl-field[data-type="computed"]');
    for (let pass = 0; pass <= $computed.length; pass++) {
        let progressed = false;
        $computed.each(function () {
            const key = $(this).data('key');
            if (key in vars) return;
            const r = evalFormula($(this).data('formula'), vars);
            if (r !== null) { vars[key] = r; $(this).val(r); progressed = true; }
        });
        if (!progressed) break;
    }
    $computed.each(function () {
        if (!($(this).data('key') in vars)) $(this).val('');
    });
}

// Average Bunch Weight (kg) used by Total Weight: the monthly ABW entered per block in the
// template's Monthly Targets dialog — the PREVIOUS month's, or the current month's when the
// previous month has none.
let dlAbw = null;
const DL_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Load the ABW for the entry date (or the task's period) and show both months in the header.
function dlLoadAbw() {
    const data = { task_id: $('#dailyLogForm').attr('data-task-id') };
    if ($('#dl-date').val()) data.date = $('#dl-date').val();
    return $.get('/api/task/daily-log/abw', data).done(function (r) {
        dlAbw = (r.abw === null || r.abw === undefined) ? null : r.abw;
        const part = (p, used) => {
            const label = `${DL_MONTHS[p.month - 1]} ${p.year}: `;
            const val = p.abw === null || p.abw === undefined ? 'null' : p.abw + ' kg';
            return used ? `${label}<b class="text-slate-700">${val}</b> <span class="text-xs text-emerald-600">(used)</span>`
                        : `${label}<span class="text-slate-500">${val}</span>`;
        };
        $('#dl-abw-val').html(part(r.previous, r.source === 'previous_month') + ' · ' + part(r.current, r.source === 'current_month'));
        $('#dl-abw-src').text(dlAbw === null ? '(not entered — set it in the template\'s Monthly Targets)' : '');
        recomputeDailyLog();
    }).fail(function (xhr) {
        Toast.show(xhr.responseJSON?.error || 'Failed to load ABW.', 'error', 3000);
    });
}

// Costs: Total = Labour + Material + Other, filled in automatically in both the Daily Log
// form (dl-) and the Edit entry form (edl-). Blank when none of the three is entered.
function dlSumCosts(prefix) {
    const parts = ['labour', 'material', 'other'].map(k => $(`#${prefix}-${k}-cost`).val());
    const entered = parts.filter(v => v !== '' && v != null && !isNaN(v));
    $(`#${prefix}-total-cost`).val(entered.length ? Math.round(entered.reduce((a, v) => a + parseFloat(v), 0) * 100) / 100 : '');
}
$(document).on('input', '#dl-labour-cost, #dl-material-cost, #dl-other-cost', function () { dlSumCosts('dl'); });
$(document).on('input', '#edl-labour-cost, #edl-material-cost, #edl-other-cost', function () { dlSumCosts('edl'); });

// Kept across a Daily Log modal session so the entry list + summary can read them.
let dlFields = [];
let dlLogs = [];
let dlWorkers = [];   // the task's assigned team (for the "Number of Workers" pickers)
let dlAllWorkers = false;

function buildDailyLogForm(resp, readOnly) {
    dlFields = resp.capture_fields || [];
    const workers = resp.workers || [];
    dlWorkers = workers;
    dlAllWorkers = !!resp.all_workers;
    dlAllWorkers = !!resp.all_workers;
    // Read-only (completed task): mark the form before rendering the list so delete buttons are skipped.
    $('#dailyLogForm').attr('data-readonly', readOnly ? '1' : '0');
    // Crew operations declare a "workers"-type capture field on their template: the team is picked
    // per activity and the entry is recorded against the block — so the single top "Worker" select
    // is removed. Per-worker ops (Harvesting) have no workers-type field and keep it.
    const isCrew = (resp.capture_fields || []).some(f => f.type === 'workers');
    $('#dailyLogForm').attr('data-crew', isCrew ? '1' : '0');
    if (isCrew) {
        $('#dl-worker-wrap').parent().addClass('hidden');
    } else {
        const $input = $('#dl-worker-search');
        const $dropdown = $('#dl-worker-dropdown');
        const $loader = $('#dl-worker-search-loading');
        const $hidden = $('#dl-worker');
        
        initPaginatedWorkerSearch($input, $dropdown, $loader, function(user) {
            $input.val(`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || String(user.id));
            $hidden.val(user.id);
            $dropdown.addClass('hidden');
        }, dlAllWorkers ? null : dlWorkers);
        
        $(document).on('click.dlworker', function (e) {
            if (!$(e.target).closest('#dl-worker-wrap').length) {
                $dropdown.addClass('hidden');
            }
        });
        
        if (workers.length === 1) {
            $input.val(workers[0].user_name || workers[0].user_id);
            $hidden.val(workers[0].user_id);
        }
    }

    // Suggest the next round number (highest existing + 1).
    const maxRound = (resp.logs || []).reduce(function (m, l) { return Math.max(m, l.round_no || 0); }, 0);
    $('#dl-round').val(maxRound + 1);

    // Capture fields grouped by section
    const fieldsWrap = $('#dl-fields');
    const sections = {};
    (resp.capture_fields || []).forEach(function (f) {
        const s = f.section || 'Details';
        (sections[s] = sections[s] || []).push(f);
    });
    if ((resp.capture_fields || []).length === 0) {
        fieldsWrap.append('<p class="text-xs text-slate-400">This template has no capture fields.</p>');
    }
    Object.keys(sections).forEach(function (s) {
        const inner = sections[s].map(renderDailyLogField).join('');
        fieldsWrap.append(
            `<div class="border border-slate-200 rounded-lg p-3">
                <div class="text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">${s}</div>
                <div class="grid grid-cols-2 md:grid-cols-3 gap-3">${inner}</div>
            </div>`
        );
    });

    // Hide the cost inputs for templates that don't track costs (e.g. Harvesting).
    if (resp.track_costs === false) $('#dl-costs-section').addClass('hidden');

    // Read-only: drop the whole entry form, leaving only the "Logged days" list to review.
    if (readOnly) {
        $('#dl-date').closest('.grid').addClass('hidden');   // date / round / worker / area row
        $('#dl-fields').addClass('hidden');
        $('#dl-costs-section').addClass('hidden');
        $('#dl-remarks').closest('div').addClass('hidden');
    }

    renderDailyLogList(resp.logs || []);

    // Live-recompute computed fields (e.g. ABW, mt/ha) as numbers/area change.
    $('#dl-fields').on('input', '.dl-field[data-type="number"]', recomputeDailyLog);
    $('#dl-area').on('input', recomputeDailyLog);
    dlAbw = null;
    recomputeDailyLog();

    // ABW (monthly, per block) in the header — only for templates whose formulas use it (Harvesting).
    if (resp.uses_abw) {
        $('#dl-abw-wrap').removeClass('hidden');
        dlLoadAbw();
        // Follow the entry date as soon as it is picked or typed (month decides the ABW).
        let dlAbwMonth = null;
        $('#dl-date').on('input change', function () {
            const m = ($(this).val() || '').slice(0, 7);   // YYYY-MM
            if (m.length === 7 && m !== dlAbwMonth) { dlAbwMonth = m; dlLoadAbw(); }
        });
    }

    // Pre-populate any dl-workers-container with previously saved workers and init search
    $('#dl-fields .dl-workers-container').each(function () {
        const $container = $(this);
        
        dlInitWorkerContainer($container, 'dl');
        
        const $input = $container.find('.dl-user-search');
        const $dropdown = $container.find('.dl-user-dropdown');
        const $loading = $container.find('.dl-search-loading');
        
        const getSelected = () => {
            return $container.find('.dl-selected-users .user-chip').map(function() {
                return String($(this).data('user-id'));
            }).get();
        };
        
        initPaginatedWorkerSearch($input, $dropdown, $loading, function(user, isChecked) {
            if (isChecked) {
                _dlAddWorkerChip($container, user, 'dl');
            } else {
                $container.find(`.user-chip[data-user-id="${user.id}"]`).remove();
                $container.find(`.user-chip[data-user-id="${String(user.id)}"]`).remove();
            }
        }, dlAllWorkers ? null : dlWorkers, true, getSelected);
    });
}

function dlRound2(x) { return Math.round((parseFloat(x) || 0) * 100) / 100; }

function dlFmtDate(iso) {
    const p = String(iso).split('-');
    const M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return (p.length === 3) ? `${p[2]} ${M[+p[1] - 1]} ${p[0]}` : iso;
}

// Build the grouped detail body for one entry (sections mirror the entry form).
function dlEntryDetailHtml(log) {
    const metrics = log.metrics || {};
    const sections = {};
    const order = [];
    dlFields.forEach(function (f) {
        const v = metrics[f.key];
        if (v === undefined || v === null || v === '') return;
        const s = f.section || 'Details';
        if (!sections[s]) { sections[s] = []; order.push(s); }
        const wk = metrics[f.key + '__workers'];
        const val = (Array.isArray(wk) && wk.length)
            ? `${wk.map(x => x.name || x.id).join(', ')} (${wk.length})`
            : v + (f.unit ? (' ' + f.unit) : '');
        sections[s].push({ label: f.label, val: val });
    });

    // Stacked label-over-value so the value is unmistakably tied to its label.
    function pairRow(label, val) {
        return `<div class="py-1 border-b border-slate-100 last:border-0">
                    <div class="text-[11px] text-slate-400 leading-tight">${label}</div>
                    <div class="text-sm font-semibold text-slate-800 leading-tight">${val}</div>
                </div>`;
    }
    function group(title, items) {
        return `<div>
                    <div class="text-[11px] font-semibold uppercase tracking-wide text-slate-400 mb-1">${title}</div>
                    <div class="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-1.5">${items.map(it => pairRow(it.label, it.val)).join('')}</div>
                </div>`;
    }

    // Entry meta (area covered + round) — shown at the top of the detail.
    let html = '';
    const meta = [];
    if (log.area_covered != null && log.area_covered !== '') meta.push({ label: 'Area Covered', val: dlRound2(log.area_covered) + ' Ha' });
    if (log.round_no != null && log.round_no !== '') meta.push({ label: 'Round', val: log.round_no });
    if (meta.length) html += group('Entry', meta);
    html += order.map(s => group(s, sections[s])).join('');

    const costs = [['labour_cost', 'Labour'], ['material_cost', 'Material'], ['other_cost', 'Other'], ['total_cost', 'Total']]
        .filter(c => log[c[0]] != null && log[c[0]] !== '')
        .map(c => ({ label: c[1], val: log[c[0]] }));
    if (costs.length) html += group('Costs', costs);

    if (log.remarks) html += `<div class="text-slate-600"><span class="text-slate-400">Remarks: </span>${log.remarks}</div>`;
    return html || '<span class="text-slate-400">No values recorded.</span>';
}

// One expandable card per entry; clicking it reveals that entry's full data.
function renderDailyLogList(logs) {
    dlLogs = logs || [];
    $('#dl-summary').addClass('hidden');   // close stale summary on refresh
    $('#dl-summary-btn').removeClass('bg-blue-50 border-blue-300 text-blue-700');
    const readOnly = $('#dailyLogForm').attr('data-readonly') === '1';   // completed task → no delete
    const box = $('#dl-existing');
    box.empty();
    if (!dlLogs.length) {
        box.append('<p class="text-xs text-slate-400 text-center py-3">No days logged yet.</p>');
        return;
    }
    dlLogs.forEach(function (log) {
        const who = log.worker_name
            ? `<span class="inline-flex items-center rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 px-2 py-0.5 text-[11px] font-medium">${log.worker_name}</span>`
            : '';
        const round = (log.round_no != null && log.round_no !== '')
            ? `<span class="inline-flex items-center rounded-full bg-amber-50 text-amber-700 border border-amber-200 px-2 py-0.5 text-[11px] font-medium">Round ${log.round_no}</span>`
            : '';
        const area = (log.area_covered != null)
            ? `<span class="text-xs text-slate-500">${dlRound2(log.area_covered)} Ha</span>` : '';
        box.append(
            `<div class="dl-log-item border border-slate-200 rounded-lg overflow-hidden bg-white" data-log-id="${log.id}">
                <div role="button" tabindex="0" class="dl-log-head w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-slate-50 cursor-pointer">
                    <span class="flex items-center gap-2 flex-wrap min-w-0 flex-1">
                        <i class="bi bi-calendar3 text-slate-400"></i>
                        <span class="text-sm font-medium text-slate-800">${dlFmtDate(log.log_date)}</span>
                        ${round}${who}
                    </span>
                    <span class="shrink-0 flex items-center gap-2">
                        ${area}
                        ${readOnly ? '' : `<button type="button" class="dl-log-edit inline-flex items-center justify-center w-6 h-6 rounded border border-blue-200 text-blue-600 hover:bg-blue-50 text-xs" data-log-id="${log.id}" title="Edit entry">
                            <i class="bi bi-pencil-fill pointer-events-none"></i>
                        </button>`}
                        ${readOnly ? '' : `<button type="button" class="dl-log-delete inline-flex items-center justify-center w-6 h-6 rounded border border-red-200 text-red-500 hover:bg-red-50 text-xs" data-log-id="${log.id}" title="Delete entry">
                            <i class="bi bi-trash3-fill pointer-events-none"></i>
                        </button>`}
                        <span class="dl-toggle-label text-xs font-medium text-blue-600">View</span>
                        <i class="bi bi-chevron-right dl-chev text-slate-400 text-xs"></i>
                    </span>
                </div>
                <div class="dl-log-detail hidden px-4 py-3 text-xs space-y-3 bg-slate-50 border-t border-slate-100">${dlEntryDetailHtml(log)}</div>
            </div>`
        );
    });
}

// Build the totals panel: sum of area + every numeric/computed field, plus a per-worker split.
const dlSummable = f => f.type === 'number' || f.type === 'workers' || f.type === 'computed';
function buildDailyLogSummary() {
    if (!dlLogs.length) return '<p class="text-xs text-slate-500">No entries to summarise yet.</p>';
    let totalArea = 0;
    const sums = {}, counts = {}, dates = {}, perWorker = {};
    dlLogs.forEach(function (log) {
        if (log.area_covered != null && !isNaN(log.area_covered)) totalArea += parseFloat(log.area_covered);
        dates[log.log_date] = true;
        const w = log.worker_name || log.worker_id || '—';
        const wk = perWorker[w] = perWorker[w] || { area: 0, entries: 0, dates: {}, sums: {}, counts: {} };
        wk.area += parseFloat(log.area_covered) || 0;
        wk.entries += 1;
        wk.dates[log.log_date] = true;
        dlFields.forEach(function (f) {
            if (!dlSummable(f)) return;
            const v = (log.metrics || {})[f.key];
            if (v !== undefined && v !== null && v !== '' && !isNaN(v)) {
                sums[f.key] = (sums[f.key] || 0) + parseFloat(v);
                counts[f.key] = (counts[f.key] || 0) + 1;
                wk.sums[f.key] = (wk.sums[f.key] || 0) + parseFloat(v);
                wk.counts[f.key] = (wk.counts[f.key] || 0) + 1;
            }
        });
    });
    let rows = `<div class="flex justify-between text-xs font-semibold text-slate-800"><span>Entries</span><span>${dlLogs.length} (${Object.keys(dates).length} days)</span></div>`;
    rows += `<div class="flex justify-between text-xs"><span class="text-slate-600">Total Area Covered</span><span class="text-slate-900 font-medium">${dlRound2(totalArea)} Ha</span></div>`;
    dlFields.forEach(function (f) {
        if (!dlSummable(f) || sums[f.key] === undefined) return;
        // Computed values can be missing on some entries (e.g. Total Weight before the ABW is set).
        const partial = f.type === 'computed' && counts[f.key] < dlLogs.length
            ? ` <span class="text-amber-600 font-normal" title="Missing on ${dlLogs.length - counts[f.key]} entries">(${counts[f.key]}/${dlLogs.length} entries)</span>` : '';
        rows += `<div class="flex justify-between text-xs"><span class="text-slate-600">${f.label}</span><span class="text-slate-900 font-medium">${dlRound2(sums[f.key])}${f.unit ? (' ' + f.unit) : ''}${partial}</span></div>`;
    });
    // Per worker: a small card with their entries, area and the same field totals as above.
    let pw = Object.keys(perWorker).map(function (w) {
        const p = perWorker[w];
        let lines = `<div class="flex justify-between text-xs"><span class="text-slate-500">Area Covered</span><span class="text-slate-900 font-medium">${dlRound2(p.area)} Ha</span></div>`;
        dlFields.forEach(function (f) {
            if (!dlSummable(f) || p.sums[f.key] === undefined) return;
            const partial = f.type === 'computed' && p.counts[f.key] < p.entries
                ? ` <span class="text-amber-600 font-normal" title="Missing on ${p.entries - p.counts[f.key]} entries">(${p.counts[f.key]}/${p.entries})</span>` : '';
            lines += `<div class="flex justify-between text-xs"><span class="text-slate-500">${f.label}</span><span class="text-slate-900 font-medium">${dlRound2(p.sums[f.key])}${f.unit ? (' ' + f.unit) : ''}${partial}</span></div>`;
        });
        return `<div class="rounded-md bg-white/70 border border-blue-100 px-2.5 py-2 space-y-0.5">
                <div class="flex justify-between items-center text-xs mb-1"><span class="font-semibold text-slate-800"><i class="bi bi-person-fill text-blue-500 mr-1"></i>${w}</span><span class="text-slate-500">${p.entries} entries · ${Object.keys(p.dates).length} days</span></div>
                ${lines}
            </div>`;
    }).join('');
    return `<div class="space-y-1">
            <div class="flex items-center justify-between mb-1">
                <div class="text-xs font-semibold text-blue-800">Summary</div>
                <button type="button" class="dl-summary-close inline-flex items-center justify-center w-5 h-5 rounded text-blue-600 hover:bg-blue-100" title="Close summary"><i class="bi bi-x-lg text-xs"></i></button>
            </div>${rows}
            <div class="mt-2 pt-2 border-t border-blue-200"><div class="text-xs font-semibold text-blue-800 mb-1">By worker</div><div class="space-y-2">${pw}</div></div></div>`;
}

// Expand/collapse a single entry.
$(document).on('click', '.dl-log-head', function (e) {
    // Ignore clicks that originated on the edit/delete buttons inside the header.
    if ($(e.target).closest('.dl-log-delete, .dl-log-edit').length) return;
    const detail = $(this).siblings('.dl-log-detail');
    detail.toggleClass('hidden');
    $(this).find('.dl-chev').toggleClass('bi-chevron-right bi-chevron-down');
    $(this).find('.dl-toggle-label').text(detail.hasClass('hidden') ? 'View' : 'Hide');
});

// Delete a single daily log entry (with confirmation dialog).
$(document).on('click', '.dl-log-delete', function (e) {
    e.stopPropagation(); // prevent the expand/collapse toggle from firing
    const logId = $(this).data('log-id');
    const $card = $(this).closest('.dl-log-item');
    if (!logId) {
        Toast.show('Log ID not found.', 'error', 3000);
        return;
    }
    const dialog = new Dialog(
        'Confirm Deletion',
        '<p>Are you sure you want to <strong>delete</strong> this daily log entry? This action cannot be undone.</p>',
        { size: 'md' }
    );
    dialog.setButtons([
        { name: 'Cancel', dismiss: true },
        {
            name: 'Delete',
            class: 'bg-red-600 text-white hover:bg-red-700',
            onClick: function () {
                const btn = $(this);
                const loadingBtn = new LoadingButton(btn);
                loadingBtn.start();
                const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                $.ajax({
                    url: '/api/task/daily-log/delete',
                    method: 'POST',
                    headers: { 'X-CSRFToken': csrftoken },
                    data: { log_id: logId }
                }).done(function (response) {
                    loadingBtn.stop();
                    dialog.hide();
                    Toast.show('Daily log entry deleted.', 'success', 2500);
                    $card.remove();
                    // Remove from local dlLogs array and refresh summary if open.
                    dlLogs = dlLogs.filter(function (l) { return l.id !== logId; });
                    if (!$('#dl-summary').hasClass('hidden')) {
                        $('#dl-summary').html(buildDailyLogSummary());
                    }
                    if (!dlLogs.length) {
                        $('#dl-existing').html('<p class="text-xs text-slate-400 text-center py-3">No days logged yet.</p>');
                    }
                }).fail(function (error) {
                    loadingBtn.stop();
                    Toast.show(error.responseJSON?.error || 'Failed to delete log entry.', 'error', 3000);
                });
            }
        }
    ]);
    dialog.show();
});

// ── Edit a daily log entry — opens a separate modal pre-filled with the entry ────
// One capture field input for the edit modal (own `edl-`/`.edl-field` namespace so it
// never clashes with the daily-log modal underneath). Computed fields are read-only
// (the server recomputes them on update).
function dlEditFieldHtml(f, metrics) {
    const key = f.key, type = f.type;
    const unit = f.unit ? ` <span class="text-slate-400">(${f.unit})</span>` : '';
    const lbl = `<label class="block text-xs font-medium text-slate-600 mb-1">${f.label || key}${unit}</label>`;
    const v = metrics[key];
    const sv = (v === undefined || v === null) ? '' : String(v).replace(/"/g, '&quot;');
    if (type === 'workers') {
        const pickedWorkers = (metrics[key + '__workers'] || []);
        return `<div class="col-span-2 md:col-span-3 edl-workers-container" data-key="${key}" data-type="workers" data-selected-workers='${JSON.stringify(pickedWorkers)}'>
            <div class="flex items-center gap-4 mb-2">
                ${lbl}
            </div>
            <div class="edl-selected-users flex flex-wrap gap-1.5 mb-2"></div>
            <div class="relative edl-worker-search-wrap">
                <input type="text" class="edl-user-search w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20" placeholder="Search workers to add…" autocomplete="off">
                <div class="edl-search-loading absolute right-3 top-1/2 -translate-y-1/2 hidden">
                    <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
                <div class="edl-user-dropdown absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg hidden max-h-60 overflow-y-auto"></div>
            </div>
            <div class="text-[11px] text-slate-400 mt-1">Selected: <span class="edl-wk-count">0</span></div>
        </div>`;
    }
    if (type === 'computed')
        return `<div>${lbl}<input type="text" readonly value="${sv}" class="edl-field w-full border border-slate-200 bg-slate-100 rounded-md px-3 py-2 text-sm text-slate-500" data-key="${key}" data-type="computed"></div>`;
    if (type === 'time')
        return `<div>${lbl}<input type="time" value="${sv}" class="edl-field w-full border border-slate-200 rounded-md px-3 py-2 text-sm" data-key="${key}" data-type="time"></div>`;
    if (type === 'text')
        return `<div>${lbl}<input type="text" value="${sv}" class="edl-field w-full border border-slate-200 rounded-md px-3 py-2 text-sm" data-key="${key}" data-type="text"></div>`;
    return `<div>${lbl}<input type="number" step="any" value="${sv}" class="edl-field w-full border border-slate-200 rounded-md px-3 py-2 text-sm" data-key="${key}" data-type="number"></div>`;
}

function openDailyLogEdit(log) {
    const isCrew = $('#dailyLogForm').attr('data-crew') === '1';
    const trackCosts = !$('#dl-costs-section').hasClass('hidden');
    const taskId = $('#dailyLogForm').attr('data-task-id');
    const metrics = log.metrics || {};
    const esc = s => String(s == null ? '' : s).replace(/</g, '&lt;');

    let workerField = '';
    if (!isCrew) {
        const currentName = (dlWorkers || []).find(w => String(w.user_id) === String(log.worker_id))?.user_name || log.worker_name || log.worker_id || '';
        workerField = `<div>
            <label class="block text-sm font-medium text-slate-700 mb-1">Worker <span class="text-red-500">*</span></label>
            <div class="relative" id="edl-worker-wrap">
                <input type="text" id="edl-worker-search" placeholder="Search worker…" autocomplete="off" value="${esc(currentName)}"
                    class="w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20" />
                <div id="edl-worker-search-loading" class="absolute right-3 top-1/2 -translate-y-1/2 hidden">
                    <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
                <div id="edl-worker-dropdown" class="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg hidden max-h-60 overflow-y-auto"></div>
                <input type="hidden" id="edl-worker" value="${log.worker_id || ''}" />
            </div>
        </div>`;
    }

    const sections = {};
    (dlFields || []).forEach(f => { const s = f.section || 'Details'; (sections[s] = sections[s] || []).push(f); });
    const fieldsHtml = Object.keys(sections).map(s => {
        const inner = sections[s].map(f => dlEditFieldHtml(f, metrics)).join('');
        return `<div class="border border-slate-200 rounded-lg p-3"><div class="text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">${s}</div><div class="grid grid-cols-2 md:grid-cols-3 gap-3">${inner}</div></div>`;
    }).join('');

    const cost = (id, ph, val) => `<input type="number" id="${id}" step="any" min="0" placeholder="${ph}" value="${val != null ? val : ''}" class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm">`;
    // Total is Labour + Material + Other (read-only; the server recomputes it on save).
    const totalCost = `<input type="number" id="edl-total-cost" step="any" placeholder="Total (auto)" readonly title="Labour + Material + Other" value="${log.total_cost != null ? log.total_cost : ''}" class="w-full rounded-md border border-slate-200 bg-slate-100 px-3 py-2 text-sm text-slate-600">`;
    const costsHtml = trackCosts ? `<div><label class="block text-sm font-medium text-slate-700 mb-2">Costs (optional)</label>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">${cost('edl-labour-cost', 'Labour', log.labour_cost)}${cost('edl-material-cost', 'Material', log.material_cost)}${cost('edl-other-cost', 'Other', log.other_cost)}${totalCost}</div></div>` : '';

    const content = `<div id="edlForm" class="p-6 space-y-5" data-crew="${isCrew ? '1' : '0'}" data-task-id="${taskId}" data-log-id="${log.id}">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-slate-600">
          <div><label class="block text-sm font-medium text-slate-700 mb-1">Date <span class="text-red-500">*</span></label>
            <input type="date" id="edl-date" value="${log.log_date || ''}" class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"></div>
          <div><label class="block text-sm font-medium text-slate-700 mb-1">Round</label>
            <input type="number" id="edl-round" min="1" step="1" value="${log.round_no != null ? log.round_no : ''}" class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"></div>
          ${workerField}
          <div><label class="block text-sm font-medium text-slate-700 mb-1">Area covered (Ha)</label>
            <input type="number" id="edl-area" step="any" min="0" value="${log.area_covered != null ? log.area_covered : ''}" class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm"></div>
        </div>
        <div class="space-y-4">${fieldsHtml}</div>
        ${costsHtml}
        <div><label class="block text-sm font-medium text-slate-700 mb-1">Remarks</label>
          <textarea id="edl-remarks" rows="2" class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm">${esc(log.remarks || '')}</textarea></div>
      </div>`;

    const dlg = new Dialog('Edit Daily Log — ' + dlFmtDate(log.log_date), content, { size: '3xl' });
    dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        { name: 'Update Entry', class: 'bg-green-600 text-white hover:bg-green-700', onClick: function () { submitDailyLogEdit(dlg, $(this)); } }
    ]);
    dlg.show();

    // Pre-populate worker chips from saved data and init search
    $('#edlForm .edl-workers-container').each(function () {
        const $container = $(this);
        
        dlInitWorkerContainer($container, 'edl');
        
        const $input = $container.find('.edl-user-search');
        const $dropdown = $container.find('.edl-user-dropdown');
        const $loading = $container.find('.edl-search-loading');
        
        const getSelected = () => {
            return $container.find('.edl-selected-users .user-chip').map(function() {
                return String($(this).data('user-id'));
            }).get();
        };
        
        initPaginatedWorkerSearch($input, $dropdown, $loading, function(user, isChecked) {
            if (isChecked) {
                _dlAddWorkerChip($container, user, 'edl');
            } else {
                $container.find(`.user-chip[data-user-id="${user.id}"]`).remove();
                $container.find(`.user-chip[data-user-id="${String(user.id)}"]`).remove();
            }
        }, dlAllWorkers ? null : dlWorkers, true, getSelected);
    });
    
    // Add initialization for the top-level edl worker dropdown
    if (!isCrew) {
        const $input = $('#edl-worker-search');
        const $dropdown = $('#edl-worker-dropdown');
        const $loader = $('#edl-worker-search-loading');
        const $hidden = $('#edl-worker');
        
        initPaginatedWorkerSearch($input, $dropdown, $loader, function(user) {
            $input.val(`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || String(user.id));
            $hidden.val(user.id);
            $dropdown.addClass('hidden');
        }, dlAllWorkers ? null : dlWorkers);
        
        $(document).on('click.edlworker', function (e) {
            if (!$(e.target).closest('#edl-worker-wrap').length) {
                $dropdown.addClass('hidden');
            }
        });
    }
}

function submitDailyLogEdit(dlg, btn) {
    const loadingBtn = new LoadingButton(btn);
    loadingBtn.start();
    const csrftoken = $("[name=csrfmiddlewaretoken]").val();
    const $form = $('#edlForm');
    const logId = $form.attr('data-log-id');
    const taskId = $form.attr('data-task-id');
    const isCrew = $form.attr('data-crew') === '1';

    const logDate = $('#edl-date').val();
    if (!logDate) { Toast.show('Please choose a date.', 'error', 3000); loadingBtn.stop(); return; }
    const workerId = isCrew ? '' : $('#edl-worker').val();
    if (!isCrew && !workerId) { Toast.show('Please select the worker this entry is for.', 'error', 3000); loadingBtn.stop(); return; }

    const metrics = {};
    // Collect workers-type fields from containers (chip-based)
    $('#edlForm .edl-workers-container').each(function () {
        const key = $(this).data('key');
        const picked = $(this).data('selected-workers') || [];
        metrics[key] = picked.length;
        if (picked.length) metrics[key + '__workers'] = picked;
    });
    $('#edlForm .edl-field:not([data-type="workers"])').each(function () {
        const $f = $(this), key = $f.data('key'), type = $f.data('type');
        if (type === 'workers') return;
        if (type === 'computed') return;   // server recomputes
        const raw = $f.val();
        if (raw === '' || raw == null) return;
        metrics[key] = (type === 'number') ? parseFloat(raw) : raw;
    });

    $.ajax({
        url: '/api/task/daily-log/update', method: 'POST', headers: { 'X-CSRFToken': csrftoken },
        data: {
            log_id: logId, log_date: logDate, round_no: $('#edl-round').val(),
            worker_id: workerId, worker_name: isCrew ? '' : $('#edl-worker-search').val(),
            area_covered: $('#edl-area').val(), metrics: JSON.stringify(metrics),
            labour_cost: $('#edl-labour-cost').val() || '', material_cost: $('#edl-material-cost').val() || '',
            other_cost: $('#edl-other-cost').val() || '', total_cost: $('#edl-total-cost').val() || '',
            remarks: $('#edl-remarks').val(),
        }
    }).done(function () {
        Toast.show('Daily log updated.', 'success', 2500);
        dlg.hide();
        if (taskId) $.get('/api/task/daily-log/list', { task_id: taskId }).done(function (lr) { renderDailyLogList(lr.logs || []); });
    }).fail(function (error) {
        Toast.show(error.responseJSON?.error || 'Failed to update daily log.', 'error', 3000);
    }).always(function () { loadingBtn.stop(); });
}

// Open the edit modal for the clicked entry.
$(document).on('click', '.dl-log-edit', function (e) {
    e.stopPropagation();
    const logId = $(this).data('log-id');
    const log = (dlLogs || []).find(function (l) { return String(l.id) === String(logId); });
    if (!log) { Toast.show('Entry not found.', 'error', 3000); return; }
    openDailyLogEdit(log);
});

// Toggle the totals panel.
$(document).on('click', '#dl-summary-btn', function () {
    const panel = $('#dl-summary');
    if (!panel.hasClass('hidden')) { panel.addClass('hidden'); $(this).removeClass('bg-blue-50 border-blue-300 text-blue-700'); return; }
    panel.html(buildDailyLogSummary()).removeClass('hidden');
    $(this).addClass('bg-blue-50 border-blue-300 text-blue-700');
});

// Close (×) button inside the summary panel.
$(document).on('click', '.dl-summary-close', function () {
    $('#dl-summary').addClass('hidden');
    $('#dl-summary-btn').removeClass('bg-blue-50 border-blue-300 text-blue-700');
});

$(document).on('click', '.task-daily-log', function () {
    const taskId = $(this).data('id');
    if (!taskId) {
        Toast.show("Task ID not found.", "error", 3000);
        return;
    }
    $.get('/api/task/daily-log/modal', { task_id: taskId }).done(function (resp) {
        const readOnly = !!resp.read_only;   // completed tasks → view-only (no entry form, no save/delete)
        const dialog = new Dialog(readOnly ? "Daily Log (View only)" : "Daily Log", resp.html, { size: '3xl' });
        const buttons = [{ name: "Close", dismiss: true }];
        if (!readOnly) buttons.push(
            {
                name: "Save Entry",
                class: "bg-green-600 text-white hover:bg-green-700",
                onClick: function () {
                    const btn = $(this);
                    const loadingBtn = new LoadingButton(btn);
                    loadingBtn.start();
                    const csrftoken = $("[name=csrfmiddlewaretoken]").val();

                    const logDate = $('#dl-date').val();
                    if (!logDate) {
                        Toast.show("Please choose a date.", "error", 3000);
                        loadingBtn.stop();
                        return;
                    }
                    const isCrew = $('#dailyLogForm').attr('data-crew') === '1';
                    const workerId = isCrew ? '' : $('#dl-worker').val();
                    if (!isCrew && !workerId) {
                        Toast.show("Please select the worker this entry is for.", "error", 3000);
                        loadingBtn.stop();
                        return;
                    }

                    const metrics = {};
                    // Collect workers-type fields from containers (chip-based)
                    $('#dl-fields .dl-workers-container').each(function () {
                        const key = $(this).data('key');
                        const picked = $(this).data('selected-workers') || [];
                        metrics[key] = picked.length;
                        if (picked.length) metrics[key + '__workers'] = picked;
                    });
                    $('#dl-fields .dl-field:not([data-type="workers"])').each(function () {
                        const $f = $(this);
                        const key = $f.data('key');
                        const type = $f.data('type');
                        if (type === 'workers') return; // handled above
                        const raw = $f.val();
                        if (raw === '' || raw == null) return;
                        metrics[key] = (type === 'number') ? parseFloat(raw) : raw;
                    });

                    $.ajax({
                        url: '/api/task/daily-log/add',
                        method: 'POST',
                        headers: { 'X-CSRFToken': csrftoken },
                        data: {
                            task_id: taskId,
                            log_date: logDate,
                            round_no: $('#dl-round').val(),
                            worker_id: workerId,
                            worker_name: isCrew ? '' : $('#dl-worker-search').val(),
                            area_covered: $('#dl-area').val(),
                            metrics: JSON.stringify(metrics),
                            labour_cost: $('#dl-labour-cost').val(),
                            material_cost: $('#dl-material-cost').val(),
                            other_cost: $('#dl-other-cost').val(),
                            total_cost: $('#dl-total-cost').val(),
                            remarks: $('#dl-remarks').val(),
                        }
                    }).done(function (r) {
                        Toast.show("Daily log saved.", "success", 2500);
                        // Reset entry inputs and refresh the logged-days list.
                        $('#dl-fields .dl-field, #dl-area, #dl-remarks, #dl-labour-cost, #dl-material-cost, #dl-other-cost, #dl-total-cost').val('');
                        // Reset worker containers
                        $('#dl-fields .dl-workers-container').each(function () {
                            $(this).attr('data-selected-workers', '[]');
                            $(this).find('.dl-selected-users').empty();
                            $(this).find('.dl-wk-count').text('0');
                            $(this).find('.dl-worker-search-wrap').removeClass('hidden');
                        });
                        $.get('/api/task/daily-log/list', { task_id: taskId }).done(function (lr) {
                            renderDailyLogList(lr.logs || []);
                        });
                    }).fail(function (error) {
                        Toast.show(error.responseJSON?.error || "Failed to save daily log.", "error", 3000);
                    }).always(function () {
                        loadingBtn.stop();
                    });
                }
            }
        );
        dialog.setButtons(buttons);
        dialog.setEvents([{ action: 'show', callback: function () { buildDailyLogForm(resp, readOnly); } }]);
        dialog.show();
    }).fail(function (error) {
        Toast.show(error.responseJSON?.error || "Failed to load daily log.", "error", 3000);
    });
});

let taskData = [];
let allDataFields = new Set();
let chartInstances = {};
let fieldColors = {};


const colorPalette = [
    '#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6',
    '#06b6d4', '#84cc16', '#f97316', '#ec4899', '#6366f1'
];

function updateTaskData(newTaskData) {


    // Update global task data
    taskData = newTaskData;

    // Reset global variables
    allDataFields.clear();
    Object.keys(chartInstances).forEach(key => {
        if (chartInstances[key] && typeof chartInstances[key].destroy === 'function') {
            chartInstances[key].destroy();
        }
    });
    chartInstances = {};
    fieldColors = {};

    // Clear existing UI elements
    clearDashboard();

    // Rebuild dashboard with new data
    if (taskData.length > 0) {
        analyzeDataFields();
        createCombinedCharts();
        console.log(`Dashboard updated successfully with ${taskData.length} tasks`);
    } else {
        return;
    }
}
function clearDashboard() {
    $('#chartCardsContainer').empty();
}


function analyzeDataFields() {
    taskData.forEach(task => {
        let entryData = task.entry_data;

        // Parse if it's a string
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                console.error('Failed to parse entry_data:', e);
                return;
            }
        }

        if (entryData && typeof entryData === 'object') {
            Object.keys(entryData).forEach(field => {
                allDataFields.add(field);
            });
        }
    });

    // Assign colors to fields
    let colorIndex = 0;
    allDataFields.forEach(field => {
        fieldColors[field] = colorPalette[colorIndex % colorPalette.length];
        colorIndex++;
    });

    console.log(`Detected ${allDataFields.size} unique data fields:`, Array.from(allDataFields));
}

function createCombinedCharts() {
    const chartContainer = $('#chartCardsContainer');

    if (allDataFields.size === 0) {
        chartContainer.html(`
            <div class="col-span-full bg-slate-50 border border-slate-200 rounded-lg p-8 text-center">
                <i class="bi bi-graph-up text-slate-400 text-4xl mb-4"></i>
                <h3 class="text-lg font-semibold text-slate-700 mb-2">No Data to Chart</h3>
                <p class="text-slate-500">Charts will appear here once tasks have entry_data.</p>
            </div>
        `);
        return;
    }

    // Group tasks by template_id
    const templateGroups = {};
    taskData.forEach(task => {
        if (!task.template_id) return;

        if (!templateGroups[task.template_id]) {
            templateGroups[task.template_id] = {
                name: task.name,
                tasks: []
            };
        }
        templateGroups[task.template_id].tasks.push(task);
    });

    // Create section for each template
    Object.entries(templateGroups).forEach(([templateId, templateData]) => {
        // Group tasks by block within this template
        const blockGroups = {};
        templateData.tasks.forEach(task => {
            if (!task.block_id) return;

            if (!blockGroups[task.block_id]) {
                blockGroups[task.block_id] = {
                    name: task.block_name,
                    tasks: []
                };
            }
            blockGroups[task.block_id].tasks.push(task);
        });

        // Count total blocks and tasks for this template
        const totalBlocks = Object.keys(blockGroups).length;
        const totalTasks = templateData.tasks.length;

        // Find best performing block
        let bestBlock = null;
        let bestBlockScore = 0;

        Object.entries(blockGroups).forEach(([blockId, blockData]) => {
            let blockTotal = 0;
            blockData.tasks.forEach(task => {
                let entryData = task.entry_data;
                if (typeof entryData === 'string') {
                    try {
                        entryData = JSON.parse(entryData);
                    } catch (e) {
                        return;
                    }
                }
                if (entryData && typeof entryData === 'object') {
                    Object.values(entryData).forEach(value => {
                        blockTotal += parseFloat(value) || 0;
                    });
                }
            });

            if (blockTotal > bestBlockScore) {
                bestBlockScore = blockTotal;
                bestBlock = blockData.name;
            }
        });

        // Create template section header
        const templateSectionHtml = `
            <div class="col-span-full bg-blue-500 border-2 border-blue-800 rounded-xl p-6 mb-4 shadow-lg">
                <div class="flex items-center justify-between">
                    <div class="flex-1">
                        <h2 class="text-2xl font-bold text-white flex items-center mb-2">
                            <i class="bi bi-clipboard2-check-fill mr-3"></i>
                            ${templateData.name}
                        </h2>
                        <div class="flex items-center gap-4 text-blue-100">
                            <span class="text-sm flex items-center">
                                <i class="bi bi-geo-alt-fill mr-1"></i>
                                ${totalBlocks} Location${totalBlocks !== 1 ? 's' : ''}
                            </span>
                            <span class="text-sm flex items-center">
                                <i class="bi bi-list-task mr-1"></i>
                                ${totalTasks} Task${totalTasks !== 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>
                    <div class="flex gap-3">
                        ${bestBlock ? `
                        <div class="bg-emerald-500/30 backdrop-blur-sm border border-emerald-300 rounded-lg px-4 py-2">
                            <p class="text-xs text-emerald-100 mb-1 flex items-center">
                                <i class="bi bi-trophy-fill mr-1"></i> Best Performing
                            </p>
                            <p class="text-sm font-semibold text-white">${bestBlock}</p>
                        </div>
                        ` : ''}
                    </div>
                </div>
            </div>
        `;
        chartContainer.append(templateSectionHtml);

        // Create charts for each block in this template
        Object.entries(blockGroups).forEach(([blockId, blockData]) => {
            // Get fields from this block's tasks
            const blockFields = new Set();
            blockData.tasks.forEach(task => {
                let entryData = task.entry_data;
                if (typeof entryData === 'string') {
                    try {
                        entryData = JSON.parse(entryData);
                    } catch (e) {
                        return;
                    }
                }
                if (entryData && typeof entryData === 'object') {
                    Object.keys(entryData).forEach(field => blockFields.add(field));
                }
            });

            // Check if this block has any data to chart
            if (blockFields.size === 0) {
                const noDataHtml = `
                    <div class="col-span-full bg-slate-50 border-2 border-slate-200 rounded-xl p-8 text-center">
                        <i class="bi bi-clipboard-x text-slate-400 text-5xl mb-4 block"></i>
                        <h3 class="text-xl font-semibold text-slate-700 mb-2">No Data Available</h3>
                        <p class="text-sm text-slate-400">Charts will appear once tasks have entry data.</p>
                    </div>
                `;
                chartContainer.append(noDataHtml);
                return;
            }

            // Create chart for each field in this block
            blockFields.forEach(field => {
                const chartId = `chart_${templateId}_${blockId}_${field}`.replace(/[^a-zA-Z0-9]/g, '_');
                const taskCount = blockData.tasks.length;

                const chartCardHtml = `
                    <div class="bg-white border-2 border-slate-200 rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                        <!-- Header with Location and Field -->
                        <div class="mb-5">
                            <div class="flex items-start justify-between mb-3">
                                <div class="flex-1">
                                    <!-- Location Badge -->
                                    <div class="inline-flex items-center bg-emerald-100 text-emerald-800 border border-emerald-300 rounded-lg px-4 py-2 mb-3">
                                        <i class="bi bi-geo-alt-fill text-lg mr-2"></i>
                                        <span class="font-semibold text-base">${blockData.name}</span>
                                    </div>
                                    
                                    <!-- Field Name -->
                                    <h3 class="text-2xl font-bold text-slate-900 flex items-center">
                                        <i class="bi bi-graph-up-arrow mr-2" style="color: ${fieldColors[field]}"></i>
                                        ${formatFieldName(field)}
                                    </h3>
                                    <p class="text-sm text-slate-500 mt-1">
                                        Tracking ${taskCount} task${taskCount !== 1 ? 's' : ''} for this measurement
                                    </p>
                                </div>
                                
                                <!-- Best Result Badge -->
                                <div class="text-center">
                                    <div class="inline-flex flex-col items-center bg-blue-50 border-2 border-blue-300 rounded-xl px-4 py-3 min-w-[100px]">
                                        <i class="bi bi-star-fill text-2xl mb-1 text-blue-600"></i>
                                        <div class="text-2xl font-bold text-blue-800">${getFieldMaxForBlock(blockData.tasks, field)}</div>
                                        <div class="text-xs font-medium uppercase tracking-wide text-blue-700">Best Result</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Chart Area -->
                        <div class="bg-gradient-to-br from-slate-50 to-white border border-slate-200 rounded-lg p-4">
                            <div class="relative h-80">
                                <canvas id="${chartId}"></canvas>
                            </div>
                        </div>
                        
                        <!-- Legend -->
                        <div class="mt-4 flex items-center justify-center gap-6 text-sm">
                            <div class="flex items-center">
                                <div class="w-4 h-4 rounded-full mr-2" style="background-color: ${fieldColors[field]}"></div>
                                <span class="text-slate-700">Actual Performance</span>
                            </div>
                            <div class="flex items-center">
                                <div class="w-4 h-4 rounded-full bg-purple-600 mr-2"></div>
                                <span class="text-slate-700">Monthly Target</span>
                            </div>
                        </div>
                    </div>
                `;

                chartContainer.append(chartCardHtml);

                // Create chart for this block's field
                setTimeout(() => createBlockFieldChart(blockId, field, blockData.tasks, chartId), 100);
            });
        });
    });
}

function getFieldTargetInfo(field) {
    const fieldData = getFieldData(field);
    const avgActual = fieldData.length > 0 ? fieldData.reduce((a, b) => a + b, 0) / fieldData.length : 0;

    // Get all targets for this field based on new structure
    const targets = [];
    taskData.forEach(task => {
        if (task.template__block_measurements && task.block_id) {
            const blockMeasurements = task.template__block_measurements[task.block_id];
            if (blockMeasurements && blockMeasurements[field]) {
                // Get month and year from start_at
                const startDate = new Date(task.start_at);
                const taskMonth = startDate.getMonth() + 1; // JavaScript months are 0-indexed
                const taskYear = startDate.getFullYear();

                // Find matching target for this month/year
                const monthlyTargets = blockMeasurements[field];
                const matchingTarget = monthlyTargets.find(t => t.month === taskMonth && t.year === taskYear);

                if (matchingTarget) {
                    targets.push(matchingTarget.target_value);
                }
            }
        }
    });

    const avgTarget = targets.length > 0 ? targets.reduce((a, b) => a + b, 0) / targets.length : 0;
    const achievement = avgTarget > 0 ? Math.round((avgActual / avgTarget) * 100) : 0;

    let achievementColor = 'text-slate-600';
    if (achievement >= 100) achievementColor = 'text-emerald-600';
    else if (achievement >= 80) achievementColor = 'text-amber-600';
    else if (achievement > 0) achievementColor = 'text-red-600';

    return {
        achievement: achievement,
        achievementColor: achievementColor,
        avgTarget: avgTarget
    };
}

function getBlockFieldTargetInfo(blockId, field, blockTasks) {
    const fieldData = blockTasks.map(task => {
        let entryData = task.entry_data;
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                return 0;
            }
        }
        return entryData ? (entryData[field] || 0) : 0;
    });

    const avgActual = fieldData.length > 0 ? fieldData.reduce((a, b) => a + b, 0) / fieldData.length : 0;

    // Get targets for this specific block
    const targets = [];
    blockTasks.forEach(task => {
        if (task.template__block_measurements && task.block_id === blockId) {
            const blockMeasurements = task.template__block_measurements[blockId];
            if (blockMeasurements && blockMeasurements[field]) {
                const startDate = new Date(task.start_at);
                const taskMonth = startDate.getMonth() + 1;
                const taskYear = startDate.getFullYear();

                const monthlyTargets = blockMeasurements[field];
                const matchingTarget = monthlyTargets.find(t => t.month === taskMonth && t.year === taskYear);

                if (matchingTarget) {
                    targets.push(matchingTarget.target_value);
                }
            }
        }
    });

    const avgTarget = targets.length > 0 ? targets.reduce((a, b) => a + b, 0) / targets.length : 0;
    const achievement = avgTarget > 0 ? Math.round((avgActual / avgTarget) * 100) : 0;

    let achievementColor = 'text-slate-600';
    if (achievement >= 100) achievementColor = 'text-emerald-600';
    else if (achievement >= 80) achievementColor = 'text-amber-600';
    else if (achievement > 0) achievementColor = 'text-red-600';

    return {
        achievement: achievement,
        achievementColor: achievementColor,
        avgTarget: avgTarget
    };
}

function getFieldMaxForBlock(blockTasks, field) {
    const values = blockTasks.map(task => {
        let entryData = task.entry_data;
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                return 0;
            }
        }
        return entryData ? (entryData[field] || 0) : 0;
    });
    return values.length > 0 ? Math.max(...values).toFixed(1) : '0';
}

function getFieldAverageForBlock(blockTasks, field) {
    const values = blockTasks.map(task => {
        let entryData = task.entry_data;
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                return 0;
            }
        }
        return entryData ? (entryData[field] || 0) : 0;
    });
    const avg = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : 0;
    return avg.toFixed(1);
}

function createBlockFieldChart(blockId, field, blockTasks, chartId) {
    const ctx = document.getElementById(chartId);
    if (!ctx) {
        console.error(`Canvas element not found: ${chartId}`);
        return;
    }

    // Sort tasks by start date
    const sortedTasks = blockTasks.sort((a, b) => new Date(a.start_at) - new Date(b.start_at));

    // Create labels
    const labels = sortedTasks.map(task => {
        const date = new Date(task.start_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        return date;
    });

    // Get actual values
    const actualValues = sortedTasks.map(task => {
        let entryData = task.entry_data;
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                return 0;
            }
        }
        return entryData ? (entryData[field] || 0) : 0;
    });

    // Get target values
    const targetValues = sortedTasks.map(task => {
        if (!task.template__block_measurements || task.block_id !== blockId) {
            return null;
        }

        const blockMeasurements = task.template__block_measurements[blockId];
        if (!blockMeasurements || !blockMeasurements[field]) {
            return null;
        }

        const startDate = new Date(task.start_at);
        const taskMonth = startDate.getMonth() + 1;
        const taskYear = startDate.getFullYear();

        const monthlyTargets = blockMeasurements[field];
        const matchingTarget = monthlyTargets.find(t => t.month === taskMonth && t.year === taskYear);

        return matchingTarget ? matchingTarget.target_value : null;
    });

    const datasets = [
        {
            label: `Actual ${formatFieldName(field)}`,
            data: actualValues,
            borderColor: fieldColors[field],
            backgroundColor: fieldColors[field],
            borderWidth: 3,
            fill: false,
            tension: 0.4,
            pointBackgroundColor: fieldColors[field],
            pointBorderColor: '#ffffff',
            pointBorderWidth: 3,
            pointRadius: 8,
            pointHoverRadius: 10
        },
        {
            label: `Target ${formatFieldName(field)}`,
            data: targetValues,
            borderColor: '#8b5cf6',
            backgroundColor: '#8b5cf6',
            borderWidth: 3,
            borderDash: [10, 5],
            fill: false,
            tension: 0,
            pointBackgroundColor: '#8b5cf6',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 3,
            pointRadius: 10,
            pointStyle: 'rect',
            pointHoverRadius: 12,
            spanGaps: false
        }
    ];

    const chartConfig = {
        type: 'line',
        data: {
            labels: labels,
            datasets: datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        usePointStyle: true,
                        padding: 20,
                        font: {
                            size: 12
                        }
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    titleColor: '#fff',
                    bodyColor: '#fff',
                    borderColor: 'rgba(255, 255, 255, 0.2)',
                    borderWidth: 1,
                    padding: 12,
                    titleFont: {
                        size: 13,
                        weight: 'bold'
                    },
                    bodyFont: {
                        size: 12
                    },
                    callbacks: {
                        title: function (context) {
                            const taskIndex = context[0].dataIndex;
                            const task = sortedTasks[taskIndex];
                            const startDate = new Date(task.start_at);
                            const dateStr = startDate.toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            });
                            return `Date: ${dateStr}`;
                        },
                        beforeBody: function (context) {
                            const taskIndex = context[0].dataIndex;
                            const task = sortedTasks[taskIndex];
                            return [`Task: ${task.name}`, `Worker: ${task.user_name}`, ''];
                        },
                        label: function (context) {
                            if (context.parsed.y === null) return null;
                            const isTarget = context.dataset.label.includes('Target');
                            const value = context.parsed.y;
                            const unit = getFieldUnit(field);

                            if (isTarget) {
                                return `Target: ${value} ${unit}`;
                            } else {
                                return `Actual: ${value} ${unit}`;
                            }
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: getFieldUnit(field)
                    },
                    grid: {
                        color: '#f1f5f9'
                    }
                },
                x: {
                    title: {
                        display: true,
                        text: 'Task Start Date'
                    },
                    grid: {
                        color: '#f1f5f9'
                    }
                }
            },
            interaction: {
                intersect: false,
                mode: 'index'
            }
        }
    };

    chartInstances[chartId] = new Chart(ctx, chartConfig);
}
function createCombinedFieldChart(field, chartId) {
    const ctx = document.getElementById(chartId);
    if (!ctx) {
        console.error(`Canvas element not found: ${chartId}`);
        return;
    }

    // Get actual data - sorted by start date
    const actualTasks = getTasksWithField(field);
    actualTasks.sort((a, b) => new Date(a.start_at) - new Date(b.start_at));

    // Create labels with block name for clarity
    const actualLabels = actualTasks.map(task => {
        const date = new Date(task.start_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        return `${date}\n${task.block_name}`;
    });

    // Parse entry_data if it's a string
    const actualValues = actualTasks.map(task => {
        let entryData = task.entry_data;
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                console.error('Failed to parse entry_data:', e);
                return 0;
            }
        }
        return entryData ? (entryData[field] || 0) : 0;
    });

    // Get target data based on block_id and month/year from start_at
    const targetValues = actualTasks.map(task => {
        if (!task.template__block_measurements || !task.block_id) {
            return null;
        }

        const blockMeasurements = task.template__block_measurements[task.block_id];
        if (!blockMeasurements || !blockMeasurements[field]) {
            return null;
        }

        // Get month and year from start_at
        const startDate = new Date(task.start_at);
        const taskMonth = startDate.getMonth() + 1; // JavaScript months are 0-indexed
        const taskYear = startDate.getFullYear();

        // Find matching target for this month/year
        const monthlyTargets = blockMeasurements[field];
        const matchingTarget = monthlyTargets.find(t => t.month === taskMonth && t.year === taskYear);

        return matchingTarget ? matchingTarget.target_value : null;
    });

    console.log(`${field} - Actual:`, actualValues);
    console.log(`${field} - Targets:`, targetValues);
    console.log(`${field} - Labels:`, actualLabels);

    const datasets = [
        {
            label: `Actual ${formatFieldName(field)}`,
            data: actualValues,
            borderColor: fieldColors[field],
            backgroundColor: fieldColors[field],
            borderWidth: 3,
            fill: false,
            tension: 0.4,
            pointBackgroundColor: fieldColors[field],
            pointBorderColor: '#ffffff',
            pointBorderWidth: 3,
            pointRadius: 8,
            pointHoverRadius: 10
        },
        {
            label: `Target ${formatFieldName(field)}`,
            data: targetValues,
            borderColor: '#8b5cf6',
            backgroundColor: '#8b5cf6',
            borderWidth: 3,
            borderDash: [10, 5],
            fill: false,
            tension: 0,
            pointBackgroundColor: '#8b5cf6',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 3,
            pointRadius: 10,
            pointStyle: 'rect',
            pointHoverRadius: 12,
            spanGaps: false
        }
    ];

    const chartConfig = {
        type: 'line',
        data: {
            labels: actualLabels,
            datasets: datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        usePointStyle: true,
                        padding: 20,
                        font: {
                            size: 12
                        }
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        title: function (context) {
                            const taskIndex = context[0].dataIndex;
                            const task = actualTasks[taskIndex];
                            return `${task.name} - ${new Date(task.start_at).toLocaleDateString()}`;
                        },
                        label: function (context) {
                            if (context.parsed.y === null) return null;
                            const icon = context.dataset.label.includes('Target') ? '🎯' : '📊';
                            const value = context.parsed.y;
                            const unit = getFieldUnit(field);
                            return `${icon} ${context.dataset.label}: ${value} ${unit}`;
                        },
                        afterLabel: function (context) {
                            if (context.parsed.y === null) return null;

                            const taskIndex = context.dataIndex;
                            const task = actualTasks[taskIndex];
                            const startDate = new Date(task.start_at);
                            const monthName = startDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

                            if (!context.dataset.label.includes('Target')) {
                                const targetValue = targetValues[taskIndex];
                                if (targetValue !== null && targetValue > 0) {
                                    const achievement = ((context.parsed.y / targetValue) * 100).toFixed(1);
                                    const icon = achievement >= 100 ? '✅' : achievement >= 80 ? '⚠️' : '❌';
                                    return [
                                        `${icon} Achievement: ${achievement}%`,
                                        `Target: ${targetValue} ${getFieldUnit(field)}`,
                                        `Block: ${task.block_name}`,
                                        `Month: ${monthName}`,
                                        `Due: ${new Date(task.due_at).toLocaleDateString()}`,
                                        `Worker: ${task.user_name}`
                                    ];
                                } else {
                                    return [
                                        `⚠️ No target set`,
                                        `Block: ${task.block_name}`,
                                        `Month: ${monthName}`,
                                        `Due: ${new Date(task.due_at).toLocaleDateString()}`,
                                        `Worker: ${task.user_name}`
                                    ];
                                }
                            } else {
                                return [
                                    `Target for ${monthName}`,
                                    `Block: ${task.block_name}`,
                                    `Task: ${task.name}`
                                ];
                            }
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: getFieldUnit(field)
                    },
                    grid: {
                        color: '#f1f5f9'
                    }
                },
                x: {
                    title: {
                        display: true,
                        text: 'Task Start Date'
                    },
                    grid: {
                        color: '#f1f5f9'
                    }
                }
            },
            interaction: {
                intersect: false,
                mode: 'index'
            }
        }
    };

    try {
        chartInstances[field] = new Chart(ctx, chartConfig);
        console.log(`Chart created successfully for ${field}`);
    } catch (error) {
        console.error(`Error creating chart for ${field}:`, error);
    }
}

function getFieldData(field) {
    return taskData
        .filter(task => {
            let entryData = task.entry_data;
            if (typeof entryData === 'string') {
                try {
                    entryData = JSON.parse(entryData);
                } catch (e) {
                    return false;
                }
            }
            return entryData && entryData.hasOwnProperty(field);
        })
        .map(task => {
            let entryData = task.entry_data;
            if (typeof entryData === 'string') {
                try {
                    entryData = JSON.parse(entryData);
                } catch (e) {
                    return 0;
                }
            }
            return entryData[field];
        });
}

function getTasksWithField(field) {
    return taskData.filter(task => {
        let entryData = task.entry_data;
        if (typeof entryData === 'string') {
            try {
                entryData = JSON.parse(entryData);
            } catch (e) {
                return false;
            }
        }
        return entryData && entryData.hasOwnProperty(field);
    });
}

function formatFieldName(field) {
    return field
        .replace(/_/g, ' ')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
}

function getFieldUnit(field) {
    const unitMap = {
        'water_level': '%',
        'soil_ph': 'pH',
        'quality_score': 'pts',
        'collectfruits': 'count'
    };
    return unitMap[field.toLowerCase()] || '';
}

function getFieldMax(field) {
    const data = getFieldData(field);
    return data.length > 0 ? Math.max(...data) : 0;
}

function getFieldAverage(field) {
    const data = getFieldData(field);
    return data.length > 0 ? (data.reduce((a, b) => a + b, 0) / data.length).toFixed(1) : 0;
}

let calendar;
let activeTemplateFilter = '';   // operation/template filter (empty = all)
let activeBlockFilter = '';      // block filter (empty = all)
let activeAssigneeFilter = '';   // assignee worker id filter (empty = all)

// Filter the task list + calendar by operation (task template). Respects the current
// stat-filter scope: re-fetch all-dates when an overall filter is active, else the date range.
$(document).on('change', '#templateFilter', function () {
    activeTemplateFilter = $(this).val() || '';
    if (activeStatFilter && activeStatFilter.scope === 'overall') {
        fetchAllDatesAndFilter(activeStatFilter.filter);
    } else {
        fetchTasksForDateRange(currentStartDate, currentEndDate);
    }
});

$(document).on('change', '#blockFilter', function () {
    activeBlockFilter = $(this).val() || '';
    if (activeStatFilter && activeStatFilter.scope === 'overall') {
        fetchAllDatesAndFilter(activeStatFilter.filter);
    } else {
        fetchTasksForDateRange(currentStartDate, currentEndDate);
    }
});

// ── Assignee Filter Dropdown (lazy AJAX + infinite scroll + debounced search) ──
// Mirrors the Worker Report worker picker exactly.
(function () {
    const AS_PAGE_SIZE = 15;
    let asOffset = 0, asTotal = 0, asLoading = false, asQuery = '', asSearchTimeout = null;

    const $asBtn = $('#assigneeDropdownBtn');
    const $asMenu = $('#assigneeDropdownMenu');
    const $asSearch = $('#assigneeSearch');
    const $asOpts = $('#assigneeList');
    const $asLoader = $('#assigneeLoader');
    const $asLabel = $('#assigneeDropdownLabel');
    const $asHidden = $('#assigneeHidden');

    function asRenderUser(user) {
        const firstName = user.first_name || '';
        const lastName = user.last_name || '';
        const name = (firstName + ' ' + lastName).trim() || user.username || 'Unnamed';
        return $(`<div class="assignee-opt px-4 py-3 hover:bg-slate-50 cursor-pointer border-b border-slate-100 last:border-b-0 flex flex-col" data-value="${user.id}">
          <div class="font-medium text-sm text-slate-900">${name}</div>
          <div class="text-xs text-slate-600 mt-1 flex items-center gap-2">
            <span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded font-mono">${user.emp_id || '-'}</span>
            <span class="font-mono">${user.username || 'N/A'}</span>
          </div>
        </div>`);
    }

    function asFetchWorkers(append) {
        if (asLoading) return;
        if (append && asOffset >= asTotal && asTotal > 0) return;
        asLoading = true;
        $asLoader.removeClass('hidden').addClass('flex');

        searchUserPaginated({ limit: AS_PAGE_SIZE, offset: asOffset, query: asQuery })
            .done(function (resp) {
                const users = resp.users || [];
                asTotal = resp.total || 0;
                if (!append) {
                    $asOpts.find('.assignee-opt:not([data-value=""])').remove();
                    $asOpts.find('.assignee-opt-empty').remove();
                }
                if (users.length === 0 && asOffset === 0) {
                    $asOpts.append('<div class="assignee-opt-empty px-3 py-3 text-sm text-slate-400 text-center">No workers found</div>');
                } else {
                    users.forEach(function (u) { $asOpts.append(asRenderUser(u)); });
                }
                asOffset += users.length;
            })
            .always(function () {
                asLoading = false;
                $asLoader.addClass('hidden').removeClass('flex');
            });
    }

    // Open / close the dropdown
    $asBtn.on('click', function (e) {
        e.stopPropagation();
        const isOpen = !$asMenu.hasClass('hidden');
        if (isOpen) { $asMenu.addClass('hidden').removeClass('flex'); return; }
        // Reset and open
        asQuery = ''; asOffset = 0; asTotal = 0;
        $asSearch.val('');
        $asOpts.find('.assignee-opt:not([data-value=""])').remove();
        $asOpts.find('.assignee-opt-empty').remove();
        $asMenu.removeClass('hidden').addClass('flex');
        $asSearch.focus();
        asFetchWorkers(false);
    });

    // Close on outside click
    $(document).on('click', function (e) {
        if (!$(e.target).closest('#assigneeFilterWrap').length) {
            $asMenu.addClass('hidden').removeClass('flex');
        }
    });

    // Prevent search input click from closing the menu
    $asSearch.on('click', function (e) { e.stopPropagation(); });

    // Debounced search
    $asSearch.on('input', function () {
        clearTimeout(asSearchTimeout);
        const query = $asSearch.val().trim();
        asSearchTimeout = setTimeout(function () {
            if (query.length > 0 && query.length < 3) {
                Toast.show("Please enter at least 3 characters", "error", 3000);
                return;
            }
            asQuery = query;
            asOffset = 0; asTotal = 0;
            asFetchWorkers(false);
        }, 400);
    });

    // Infinite scroll — load more when near the bottom
    $asOpts.on('scroll', function () {
        if (this.scrollTop + this.clientHeight >= this.scrollHeight - 20) {
            asFetchWorkers(true);
        }
    });

    // Click an option (delegated)
    $asOpts.on('click', '.assignee-opt', function (e) {
        e.stopPropagation();
        const val = $(this).attr('data-value');
        const text = $(this).find('.font-medium').text() || $(this).text();
        $asLabel.text(val ? text.trim() : 'All assignees');
        $asHidden.val(val);
        activeAssigneeFilter = val || '';
        $asMenu.addClass('hidden').removeClass('flex');
        // Re-fetch with new assignee filter
        if (activeStatFilter && activeStatFilter.scope === 'overall') {
            fetchAllDatesAndFilter(activeStatFilter.filter);
        } else {
            fetchTasksForDateRange(currentStartDate, currentEndDate);
        }
    });
}());

// Track current navigation state
let currentViewType = 'dayGridMonth';
let currentStartDate = new Date();
let currentEndDate = new Date();

// Map view button IDs to FullCalendar view types
const viewTypeMap = {
    'viewMonth': 'dayGridMonth',
    'viewWeek': 'timeGridWeek',
    'viewDay': 'timeGridDay',
    'viewList': 'listWeek'
};

// Update the navigation title based on current view and date range
function updateNavTitle() {
    const titleEl = $('#navTitle');
    const start = currentStartDate;
    const end = new Date(currentEndDate.getTime() - 1); // Subtract 1ms to get actual end date

    let title = '';

    if (currentViewType === 'dayGridMonth') {
        // Month view: "November 2025"
        // Use the middle of the range to get the correct month (since start could be from prev month)
        const middleDate = new Date((start.getTime() + end.getTime()) / 2);
        title = middleDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    } else if (currentViewType === 'timeGridWeek' || currentViewType === 'listWeek') {
        // Week view: "Nov 24 - 30, 2025"
        const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
        const endMonth = end.toLocaleDateString('en-US', { month: 'short' });
        const startDay = start.getDate();
        const endDay = end.getDate();
        const year = end.getFullYear();

        if (startMonth === endMonth) {
            title = `${startMonth} ${startDay} - ${endDay}, ${year}`;
        } else {
            title = `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${year}`;
        }
    } else if (currentViewType === 'timeGridDay') {
        // Day view: "November 28, 2025"
        title = start.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }

    titleEl.text(title);
}

// Update active state of view type buttons
function updateViewTypeButtons(activeViewType) {
    $('.nav-view-btn').each(function () {
        const btn = $(this);
        const btnViewType = viewTypeMap[btn.attr('id')];

        if (btnViewType === activeViewType) {
            btn.removeClass('text-slate-600 hover:bg-white/50').addClass('bg-white text-slate-700 shadow-sm');
        } else {
            btn.removeClass('bg-white text-slate-700 shadow-sm').addClass('text-slate-600 hover:bg-white/50');
        }
    });
}

// Navigate to previous period
$(document).on('click', '#navPrev', function () {
    if (calendar) {
        calendar.prev();
    } else {
        // Navigate without calendar - calculate new date range
        navigateWithoutCalendar('prev');
    }
});

// Navigate to next period
$(document).on('click', '#navNext', function () {
    if (calendar) {
        calendar.next();
    } else {
        // Navigate without calendar - calculate new date range
        navigateWithoutCalendar('next');
    }
});

// Handle navigation when calendar is not initialized
function navigateWithoutCalendar(direction) {
    const multiplier = direction === 'prev' ? -1 : 1;

    if (currentViewType === 'dayGridMonth') {
        // For month view, calculate the reference month and recalculate the full range
        const middleDate = new Date((currentStartDate.getTime() + currentEndDate.getTime()) / 2);
        middleDate.setMonth(middleDate.getMonth() + multiplier);
        calculateDateRangeForView('dayGridMonth', middleDate);
    } else if (currentViewType === 'timeGridWeek' || currentViewType === 'listWeek') {
        currentStartDate.setDate(currentStartDate.getDate() + (7 * multiplier));
        currentEndDate.setDate(currentEndDate.getDate() + (7 * multiplier));
    } else if (currentViewType === 'timeGridDay') {
        currentStartDate.setDate(currentStartDate.getDate() + multiplier);
        currentEndDate.setDate(currentEndDate.getDate() + multiplier);
    }

    updateNavTitle();
    fetchTasksForDateRange(currentStartDate, currentEndDate);
}

// Change view type (month/week/day/list)
$(document).on('click', '.nav-view-btn', function () {
    const btnId = $(this).attr('id');
    const newViewType = viewTypeMap[btnId];

    if (newViewType === currentViewType) return;

    currentViewType = newViewType;
    updateViewTypeButtons(newViewType);

    if (calendar) {
        calendar.changeView(newViewType);
    } else {
        // Calculate new date range based on view type and fetch
        calculateDateRangeForView(newViewType);
        updateNavTitle();
        fetchTasksForDateRange(currentStartDate, currentEndDate);
    }
});

// Calculate date range based on view type (matching FullCalendar's date ranges)
function calculateDateRangeForView(viewType, referenceDate = null) {
    const now = referenceDate || new Date();

    if (viewType === 'dayGridMonth') {
        // FullCalendar month view: starts from Sunday of the week containing the 1st
        // and ends on Saturday of the week containing the last day of month
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        // Start: Sunday of the week containing the 1st
        const startDayOfWeek = firstOfMonth.getDay();
        currentStartDate = new Date(firstOfMonth);
        currentStartDate.setDate(firstOfMonth.getDate() - startDayOfWeek);

        // End: Saturday of the week containing the last day (actually Sunday of next week)
        const endDayOfWeek = lastOfMonth.getDay();
        currentEndDate = new Date(lastOfMonth);
        currentEndDate.setDate(lastOfMonth.getDate() + (7 - endDayOfWeek));
    } else if (viewType === 'timeGridWeek' || viewType === 'listWeek') {
        // Sunday to Saturday of current week
        const dayOfWeek = now.getDay();
        currentStartDate = new Date(now);
        currentStartDate.setDate(now.getDate() - dayOfWeek);
        currentStartDate.setHours(0, 0, 0, 0);
        currentEndDate = new Date(currentStartDate);
        currentEndDate.setDate(currentStartDate.getDate() + 7);
    } else if (viewType === 'timeGridDay') {
        // Single day
        currentStartDate = new Date(now);
        currentStartDate.setHours(0, 0, 0, 0);
        currentEndDate = new Date(currentStartDate);
        currentEndDate.setDate(currentStartDate.getDate() + 1);
    }
}

// Initialize navigation state on page load
function initializeNavigation() {
    calculateDateRangeForView('dayGridMonth');
    updateNavTitle();
    updateViewTypeButtons('dayGridMonth');
}

// Call on document ready
$(document).ready(function () {
    // Prevent browser caching for all AJAX requests (especially GET requests for modals)
    $.ajaxSetup({ cache: false });

    initializeNavigation();
});

// Toggle between Table and Calendar display
$(document).on('click', '#listView', function () {
    switchView($(this), 'list');
});

$(document).on('click', '#calendarView', function () {
    switchView($(this), 'calendar');
});

function switchView(activeBtn, viewType) {
    const listView = $('#listView');
    const calendarView = $('#calendarView');
    const listViewContainer = $('#listViewContainer');
    const calendarViewContainer = $('#calendarViewContainer');

    // Reset all buttons
    $.each([listView, calendarView], function (index, btn) {
        btn.removeClass('bg-blue-100 text-blue-700').addClass('text-slate-600 hover:bg-slate-100');
    });

    // Activate selected button
    activeBtn.removeClass('text-slate-600 hover:bg-slate-100').addClass('bg-blue-100 text-blue-700');

    // Show/hide containers
    if (viewType === 'list') {
        listViewContainer.removeClass('hidden');
        calendarViewContainer.addClass('hidden');
        // "List" sub-view only makes sense inside the calendar toolbar.
        $('#viewList').hide();
    } else if (viewType === 'calendar') {
        $('#viewList').show();
        // Overall-scoped filters fetch all-dates data that doesn't match the
        // calendar's month window — drop the filter and reload the range.
        // Range-scoped filters carry over: applyStatFilterToCalendar() below
        // will re-apply them against the refreshed events.
        if (activeStatFilter && activeStatFilter.scope === 'overall') {
            clearStatFilter();
            fetchTasksForDateRange(currentStartDate, currentEndDate);
        }

        listViewContainer.addClass('hidden');
        calendarViewContainer.removeClass('hidden');

        // Initialize or render calendar when switching to calendar view
        if (!calendar) {
            initializeCalendar();
        } else {
            calendar.render();
        }

        // If a range filter is still active, apply it to the calendar events
        applyStatFilterToCalendar();
    }
}

// Transform tasks array into FullCalendar events format
// Colour calendar events by OPERATION (task name = the template), like the report mock —
// calmer and grouped, instead of the old all-red status colouring.
function opColor(name) {
    const n = (name || '').toLowerCase();
    if (n.indexOf('harvest') > -1) return ['#10b981', '#059669'];
    if (n.indexOf('manur') > -1) return ['#3b82f6', '#2563eb'];
    if (n.indexOf('circle') > -1) return ['#06b6d4', '#0891b2'];   // circle & path
    if (n.indexOf('spray') > -1) return ['#a855f7', '#9333ea'];   // selective spraying
    if (n.indexOf('census') > -1) return ['#f59e0b', '#d97706'];
    return ['#64748b', '#475569'];
}

function transformTasksToEvents(tasks) {
    const now = new Date();
    return tasks.map(function (task) {
        const dueAt = task.due_at ? new Date(task.due_at) : null;
        const isOverdue = task.status !== 'completed'
            && task.status !== 'cancelled'
            && dueAt && dueAt < now;
        const [bg, bd] = opColor(task.name);

        // Span the task across its start→due days so EVERY covered day is highlighted
        // (e.g. 19→20 shows on both). All-day `end` is exclusive, so add a day to include
        // the due day. dayMaxEvents caps stacking so long tasks stay clean ("+N more").
        let endExcl = null;
        if (task.due_at) { endExcl = new Date(task.due_at); endExcl.setDate(endExcl.getDate() + 1); }
        return {
            id: task.id,
            title: task.name,
            start: task.start_at || task.due_at || null,
            end: endExcl,
            allDay: true,
            extendedProps: {
                description: task.description,
                assignee: task.user_name,
                block: task.block_name || '',
                status: isOverdue ? 'overdue' : task.status,
                taskType: task.task_type,
                startAt: task.start_at,
                dueAt: task.due_at
            },
            backgroundColor: bg,
            borderColor: isOverdue ? '#ef4444' : bd,
            classNames: isOverdue ? ['nh-overdue'] : []
        };
    });
}

// Fetch tasks for a date range and update both list view and calendar view
function fetchTasksForDateRange(startDate, endDate, showToast = false) {
    // Boundaries are computed in the viewer's local timezone (same as the calendar's day
    // buckets and the displayed dates) and sent as precise UTC instants. TABLE = the actual
    // local month; CALENDAR = the full visible 6-week grid (cal_from/cal_to) so adjacent-month
    // days still show their tasks (dimmed).
    let fromDateUTC, toDateUTC;
    if (currentViewType === 'dayGridMonth') {
        const mid = new Date((startDate.getTime() + endDate.getTime()) / 2);
        const y = mid.getFullYear(), m = mid.getMonth();
        fromDateUTC = new Date(y, m, 1, 0, 0, 0, 0).toISOString();
        toDateUTC = new Date(y, m + 1, 0, 23, 59, 59, 999).toISOString();
    } else {
        fromDateUTC = startDate.toISOString();
        toDateUTC = new Date(endDate.getTime() - 1).toISOString();
    }
    // currentEndDate is the exclusive next-period midnight; -1ms = last visible instant.
    const calFrom = startDate.toISOString(), calTo = new Date(endDate.getTime() - 1).toISOString();

    $.ajax({
        url: '/api/task/fetch',
        method: 'GET',
        data: {
            from_date: fromDateUTC,
            to_date: toDateUTC,
            cal_from: calFrom,
            cal_to: calTo,
            template: activeTemplateFilter || '',
            block: activeBlockFilter || '',
            assignee: activeAssigneeFilter || ''
        }
    }).done(function (response) {
        // 1. Update list view HTML
        $('.task-table-body').html(response.html);

        // 2. Update global tasksData
        tasksData = response.tasks;

        // 3. Update calendar events if calendar is initialized
        renderTaskCalendar(response.tasks);

        // 4. Update stat counters for the filtered range
        if (response.counts) {
            $('#statTotalTasks').text(response.counts.total);
            $('#statActiveTasks').text(response.counts.active);
            $('#statCompletedTasks').text(response.counts.completed);
            $('#statOverdueTasks').text(response.counts.overdue);
        }
        if (response.overall) {
            $('#statOverallTotal').text(response.overall.total);
            $('#statOverallActive').text(response.overall.active);
            $('#statOverallCompleted').text(response.overall.completed);
            $('#statOverallOverdue').text(response.overall.overdue);
        }

        // Date navigation preserves range-scoped filters and re-applies them
        // to the freshly loaded rows. Overall-scoped filters are cleared since
        // they operate on an all-dates dataset that this fetch didn't return.
        if (activeStatFilter && activeStatFilter.scope === 'overall') {
            clearStatFilter();
        } else if (activeStatFilter && activeStatFilter.scope === 'range') {
            applyStatFilterToRows();
        }

        if (showToast) {
            Toast.show("Tasks filtered.", "success", 3000);
        }

        console.log('Tasks updated:', response.tasks.length, 'tasks loaded');
    }).fail(function (error) {
        Toast.show("Failed to fetch tasks.", "error", 3000);
    });
}

// ──────────────────────────────────────────────────────────
// Clickable stat cards → filter the visible task rows
// ──────────────────────────────────────────────────────────
let activeStatFilter = null;  // { scope: 'overall'|'range', filter: 'all'|'active'|'completed'|'overdue' }

function applyStatFilterToRows() {
    const filter = activeStatFilter ? activeStatFilter.filter : null;
    const $rows = $('.task-table-body tr[data-status]');
    if (!filter || filter === 'all') {
        $rows.show();
    } else if (filter === 'overdue') {
        $rows.each(function () {
            $(this).toggle($(this).attr('data-overdue') === '1');
        });
    } else {
        $rows.each(function () {
            $(this).toggle($(this).attr('data-status') === filter);
        });
    }

    // Empty-state row (colspan=7) has no data-status; show it only when zero visible rows remain
    const visible = $('.task-table-body tr[data-status]:visible').length;
    const $emptyRow = $('.task-table-body tr').not('[data-status]');
    if ($rows.length > 0 && visible === 0) {
        if ($emptyRow.length === 0) {
            $('.task-table-body').append('<tr class="stat-filter-empty"><td colspan="7" class="px-4 py-6 text-center text-slate-500">No tasks match this filter.</td></tr>');
        } else {
            $emptyRow.show();
        }
    } else {
        $('.stat-filter-empty').remove();
    }

    // Also re-render the calendar events with the same filter applied
    applyStatFilterToCalendar();
}

function applyStatFilterToCalendar() {
    if (!tasksData) return;
    const filter = activeStatFilter ? activeStatFilter.filter : null;
    const now = new Date();

    let visibleTasks;
    if (!filter || filter === 'all') {
        visibleTasks = tasksData;
    } else if (filter === 'overdue') {
        visibleTasks = tasksData.filter(function (t) {
            const dueAt = t.due_at ? new Date(t.due_at) : null;
            return t.status !== 'completed' && t.status !== 'cancelled' && dueAt && dueAt < now;
        });
    } else {
        visibleTasks = tasksData.filter(function (t) { return t.status === filter; });
    }

    renderTaskCalendar(visibleTasks);
}

function updateFilterBanner() {
    const $banner = $('#activeFilterBanner');
    const $label = $('#activeFilterLabel');
    const $dateNav = $('#dateNavToolbar');
    const $rangeSection = $('#rangeStatsSection');

    if (!activeStatFilter || activeStatFilter.filter === 'all' && activeStatFilter.scope === 'range') {
        $banner.addClass('hidden');
        $dateNav.removeClass('hidden');
        $rangeSection.removeClass('hidden');
    } else {
        const scopeText = activeStatFilter.scope === 'overall' ? 'All dates' : 'Selected range';
        const filterText = {
            all: 'All tasks',
            active: 'In Progress',
            completed: 'Completed',
            overdue: 'Overdue'
        }[activeStatFilter.filter] || activeStatFilter.filter;
        $label.text(`${scopeText} · ${filterText}`);
        $banner.removeClass('hidden');
        // Hide the date/month/week/day nav AND the "In selected range" stats
        // when the filter spans all dates — they no longer apply to the visible results.
        if (activeStatFilter.scope === 'overall') {
            $dateNav.addClass('hidden');
            $rangeSection.addClass('hidden');
        } else {
            $dateNav.removeClass('hidden');
            $rangeSection.removeClass('hidden');
        }
    }

    // Highlight the active card (ring)
    $('.stat-card').removeClass('ring-2 ring-blue-500 ring-offset-1');
    if (activeStatFilter) {
        $(`.stat-card[data-scope="${activeStatFilter.scope}"][data-filter="${activeStatFilter.filter}"]`)
            .addClass('ring-2 ring-blue-500 ring-offset-1');
    }
}

function clearStatFilter() {
    activeStatFilter = null;
    updateFilterBanner();
    $('.task-table-body tr').show();
    $('.stat-filter-empty').remove();
    // Restore the full task set on the calendar
    if (tasksData) renderTaskCalendar(tasksData);
}

// Fetch tasks across all dates, then apply a filter client-side
function fetchAllDatesAndFilter(filter) {
    $.ajax({
        url: '/api/task/fetch',
        method: 'GET',
        data: { all_dates: '1', template: activeTemplateFilter || '', block: activeBlockFilter || '', assignee: activeAssigneeFilter || '' }
    }).done(function (response) {
        $('.task-table-body').html(response.html);
        tasksData = response.tasks;
        renderTaskCalendar(response.tasks);
        if (response.counts) {
            $('#statTotalTasks').text(response.counts.total);
            $('#statActiveTasks').text(response.counts.active);
            $('#statCompletedTasks').text(response.counts.completed);
            $('#statOverdueTasks').text(response.counts.overdue);
        }
        if (response.overall) {
            $('#statOverallTotal').text(response.overall.total);
            $('#statOverallActive').text(response.overall.active);
            $('#statOverallCompleted').text(response.overall.completed);
            $('#statOverallOverdue').text(response.overall.overdue);
        }
        activeStatFilter = { scope: 'overall', filter: filter };
        updateFilterBanner();
        applyStatFilterToRows();
    }).fail(function () {
        Toast.show("Failed to load tasks.", "error", 3000);
    });
}

// Click handler — delegated so it survives HTML replacement
$(document).on('click', '.stat-card', function () {
    const scope = $(this).data('scope');
    const filter = $(this).data('filter');

    // Toggle off if the same card is clicked twice
    if (activeStatFilter && activeStatFilter.scope === scope && activeStatFilter.filter === filter) {
        clearStatFilter();
        // If we're currently on an overall-scoped view, go back to the date range
        if (scope === 'overall') {
            fetchTasksForDateRange(currentStartDate, currentEndDate);
        }
        return;
    }

    // Overall scope fetches all-dates tasks — calendar's month window no longer
    // applies, so force Table view. Range scope works on whatever view is active.
    if (scope === 'overall' && $('#calendarViewContainer').is(':visible')) {
        switchView($('#listView'), 'list');
    }

    if (scope === 'overall') {
        fetchAllDatesAndFilter(filter);
    } else {
        activeStatFilter = { scope: 'range', filter: filter };
        updateFilterBanner();
        applyStatFilterToRows();
    }
});

// Keyboard activation for accessibility
$(document).on('keydown', '.stat-card', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
    }
});

// Clear-filter banner button
$(document).on('click', '#clearStatFilter', function () {
    const wasOverall = activeStatFilter && activeStatFilter.scope === 'overall';
    clearStatFilter();
    if (wasOverall) {
        fetchTasksForDateRange(currentStartDate, currentEndDate);
    }
});

// Initialize FullCalendar
// ── Task calendar — custom day-summary grid (replaces FullCalendar) ──────────
// Each day shows one badge per OPERATION (= task template) active that day, so it never
// stacks into bars no matter how many tasks. Click a day for the task list. Colours are
// assigned to templates BY INDEX from a palette (no hard-coding; new templates get a colour).
const NH_PALETTE = ['#10b981', '#3b82f6', '#a855f7', '#06b6d4', '#f59e0b', '#ec4899', '#14b8a6', '#f97316', '#84cc16', '#ef4444'];
const _nhTplColors = {};
let _nhTplIdx = 0;
function tplColor(op) {
    if (!(op in _nhTplColors)) { _nhTplColors[op] = NH_PALETTE[_nhTplIdx++ % NH_PALETTE.length]; }
    return _nhTplColors[op];
}
function taskOp(t) { return t.template_name || t.name || '—'; }   // operation = the task's template
function nhDayKey(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
function nhFmtDate(iso) {
    if (!iso) return '—';
    const d = new Date(iso), M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return d.getDate() + ' ' + M[d.getMonth()];
}
// A task is active on a day when start_at(date) <= day <= due_at(date).
function tasksActiveOn(day, tasks) {
    const d0 = new Date(day.getFullYear(), day.getMonth(), day.getDate());
    return (tasks || []).filter(function (t) {
        if (!t.start_at && !t.due_at) return false;
        const s = new Date(t.start_at || t.due_at), e = new Date(t.due_at || t.start_at);
        const s0 = new Date(s.getFullYear(), s.getMonth(), s.getDate());
        const e0 = new Date(e.getFullYear(), e.getMonth(), e.getDate());
        return d0 >= s0 && d0 <= e0;
    });
}
// Task list (grouped by operation) for the day popup / day view — shows who + start→due.
function nhDayTasksHtml(active) {
    if (!active.length) return '<div class="text-sm text-slate-400 py-6 text-center">No tasks on this day.</div>';
    const now = new Date(), byOp = {};
    active.forEach(function (t) { const op = taskOp(t); (byOp[op] = byOp[op] || []).push(t); });
    return Object.keys(byOp).map(function (op) {
        const ts = byOp[op];
        return '<div class="mb-3"><div class="flex items-center gap-2 mb-1">'
            + '<span class="text-xs font-semibold px-2.5 py-1 rounded-full" style="background:' + tplColor(op) + ';color:#fff">' + op + '</span>'
            + '<span class="text-slate-400 text-sm">(' + ts.length + ')</span></div>'
            + ts.map(function (t) {
                const overdue = t.status !== 'completed' && t.status !== 'cancelled' && t.due_at && new Date(t.due_at) < now;
                const st = overdue ? 'overdue' : t.status;
                return '<div class="flex items-center justify-between gap-3 text-sm border-b border-slate-100 py-1.5">'
                    + '<span class="min-w-0 truncate text-slate-700"><i class="bi bi-geo-alt text-slate-400"></i> ' + (t.block_name || '—')
                    + ' <span class="text-slate-400">· ' + (t.user_name || '—') + '</span></span>'
                    + '<span class="flex items-center gap-2 shrink-0"><span class="text-[11px] text-slate-500"><i class="bi bi-calendar3"></i> '
                    + nhFmtDate(t.start_at) + ' → ' + nhFmtDate(t.due_at) + '</span>'
                    + '<span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ' + getStatusBadgeClass(st) + '">' + st + '</span>'
                    + '<button class="task-daily-log inline-flex items-center gap-1 rounded-md border border-slate-200 px-2 py-1 text-xs text-slate-600 hover:bg-slate-50" data-id="' + t.id + '" data-taskname="' + (t.name || taskOp(t)) + '" title="' + (t.status === 'completed' ? 'View entries (read-only)' : 'Add / view daily entry') + '">' + (t.status === 'completed' ? '<i class="bi bi-eye"></i> View' : '<i class="bi bi-pencil-square"></i> Entry') + '</button>'
                    + '</span></div>';
            }).join('') + '</div>';
    }).join('');
}
function openDayPopup(dk, tasks) {
    const p = dk.split('-').map(Number), day = new Date(p[0], p[1] - 1, p[2]);
    const active = tasksActiveOn(day, tasks);
    const title = day.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })
        + ' · ' + active.length + ' task' + (active.length !== 1 ? 's' : '');
    const dialog = new Dialog(title, nhDayTasksHtml(active), { size: 'lg' });
    dialog.setButtons([{ name: 'Close', dismiss: true }]);
    dialog.show();
}
function renderTaskCalendar(tasks) {
    tasks = tasks || [];
    const el = document.getElementById('calendar');
    if (!el) return;

    // Legend — operations present, coloured by template index.
    const ops = [];
    tasks.forEach(function (t) { const op = taskOp(t); if (ops.indexOf(op) === -1) ops.push(op); });
    let legend = '<div class="flex flex-wrap items-center gap-2 mb-3">';
    ops.forEach(function (op) { legend += '<span class="text-xs font-semibold px-2.5 py-1 rounded-full" style="background:' + tplColor(op) + ';color:#fff">' + op + '</span>'; });
    legend += '</div>';

    if (currentViewType === 'timeGridDay') {
        el.innerHTML = legend + '<div class="border border-slate-200 rounded-lg p-4">' + nhDayTasksHtml(tasksActiveOn(currentStartDate, tasks)) + '</div>';
        return;
    }

    // Month / Week grid (7 cols, Sun–Sat; currentStartDate is a Sunday for both).
    const W = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let html = legend + '<div class="grid grid-cols-7 gap-1 mb-1 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-400">'
        + W.map(function (w) { return '<div>' + w + '</div>'; }).join('') + '</div><div class="grid grid-cols-7 gap-1">';
    const focusMonth = new Date((currentStartDate.getTime() + currentEndDate.getTime()) / 2).getMonth();
    const d = new Date(currentStartDate);
    let guard = 0;
    while (d < currentEndDate && guard++ < 60) {
        const active = tasksActiveOn(d, tasks);
        const inMonth = currentViewType !== 'dayGridMonth' || d.getMonth() === focusMonth;
        const counts = {};
        active.forEach(function (t) { const op = taskOp(t); counts[op] = (counts[op] || 0) + 1; });
        const badges = Object.keys(counts).map(function (op) {
            const c = tplColor(op);
            return '<span class="nh-opbadge" title="' + op + ': ' + counts[op] + '" style="background:' + c + ';color:#fff">' + counts[op] + '</span>';
        }).join('');
        html += '<div class="nh-cell ' + (active.length ? '' : 'nh-empty') + ' ' + (inMonth ? '' : 'nh-out') + '"'
            + (active.length ? ' data-cal-day="' + nhDayKey(d) + '"' : '') + '>'
            + '<div class="nh-dnum">' + d.getDate() + '</div><div class="nh-badges">' + badges + '</div></div>';
        d.setDate(d.getDate() + 1);
    }
    html += '</div>';
    el.innerHTML = html;
    el.querySelectorAll('[data-cal-day]').forEach(function (c) {
        c.addEventListener('click', function () { openDayPopup(c.getAttribute('data-cal-day'), tasks); });
    });
}
// Kept for the existing call sites — renders the custom grid (no FullCalendar).
// Render immediately from the server-seeded (month) set so there's no blank flash, then
// fetch the full visible grid so adjacent-month days show their tasks dimmed on first open.
function initializeCalendar() {
    renderTaskCalendar(tasksData);
    fetchTasksForDateRange(currentStartDate, currentEndDate);
}

function getStatusBadgeClass(status) {
    switch (status) {
        case 'completed':
            return 'bg-emerald-100 text-emerald-700';
        case 'cancelled':
            return 'bg-red-100 text-red-700';
        case 'active':
            return 'bg-blue-100 text-blue-700';
        default:
            return 'bg-amber-100 text-amber-700';
    }
}

$('.apply-date-filter').on('click', function () {
    const fromDate = $('.from-date-input').val();
    const toDate = $('.to-date-input').val();

    if (!fromDate || !toDate) {
        Toast.show("Please select both start and end dates.", "error", 3000);
        return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
        Toast.show("Start date cannot be after end date.", "error", 3000);
        return;
    }

    const startDate = new Date(fromDate);
    const endDate = new Date(new Date(toDate).setHours(23, 59, 59, 999));

    // Fetch tasks using shared function (with toast notification)
    fetchTasksForDateRange(startDate, endDate, true);

    // Also navigate calendar to the selected date range if initialized
    if (calendar) {
        calendar.gotoDate(startDate);
    }
});

$('.clear-date-filter').on('click', function () {
    window.location.reload();
});


// ── Daily Log / Edit Daily Log: Create-Task-style chip-based worker search ──

// Helper: build a chip element and store the worker in the container's data
function _dlAddWorkerChip($container, user, prefix) {
    const name = ((user.first_name || '') + ' ' + (user.last_name || '')).trim() || user.username || String(user.user_id || user.id);
    const id   = user.id || user.user_id;
    const empId = user.emp_id || '';
    const $chips = $container.find('.' + prefix + '-selected-users');

    // Prevent duplicates
    if ($chips.find('.user-chip[data-user-id="' + id + '"]').length) return;

    // Append chip
    $chips.append(
        '<span class="user-chip inline-flex items-center gap-1.5 bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-md px-2 py-1 text-xs font-medium" data-user-id="' + id + '">' +
        name +
        (empId ? ' <span class="inline-block bg-blue-100 text-blue-800 text-xs px-1.5 py-0.5 rounded font-mono">' + empId + '</span>' : '') +
        ' <button type="button" class="dl-remove-chip text-emerald-600 hover:text-emerald-900"><i class="bi bi-x-lg"></i></button>' +
        '</span>'
    );

    // Update stored data
    const picked = $container.data('selected-workers') || [];
    picked.push({ id: id, name: name });
    $container.data('selected-workers', picked);

    // Update count
    $container.find('.' + prefix + '-wk-count').text($chips.find('.user-chip').length);
    if (typeof recomputeDailyLog === 'function') recomputeDailyLog();
}

// Helper: remove a chip by id and update the stored data
function _dlRemoveWorkerChip($container, id, prefix) {
    $container.find('.user-chip[data-user-id="' + id + '"]').remove();
    const $chips = $container.find('.' + prefix + '-selected-users');
    let picked = $container.data('selected-workers') || [];
    picked = picked.filter(function (w) { return String(w.id) !== String(id); });
    $container.data('selected-workers', picked);
    $container.find('.' + prefix + '-wk-count').text($chips.find('.user-chip').length);
    
    // Also uncheck it in the dropdown if currently visible
    $container.find('.' + prefix + '-user-dropdown [data-user-id="' + id + '"] input[type="checkbox"]').prop('checked', false);
    
    if (typeof recomputeDailyLog === 'function') recomputeDailyLog();
}

// Helper: initialise a container (e.g. pre-populate edit form with existing workers)
function dlInitWorkerContainer($container, prefix) {
    const saved = $container.data('selected-workers');
    if (!saved) $container.data('selected-workers', []);
    if (Array.isArray(saved) && saved.length) {
        saved.forEach(function (w) {
            const name = w.name || String(w.id);
            const $chips = $container.find('.' + prefix + '-selected-users');
            if ($chips.find('.user-chip[data-id="' + w.id + '"]').length) return;
            $chips.append(
                '<span class="user-chip inline-flex items-center gap-1.5 bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-md px-2 py-1 text-xs font-medium" data-id="' + w.id + '">' +
                name +
                ' <button type="button" class="dl-remove-chip text-emerald-600 hover:text-emerald-900"><i class="bi bi-x-lg"></i></button>' +
                '</span>'
            );
        });
        $container.find('.' + prefix + '-wk-count').text($container.find('.' + prefix + '-selected-users .user-chip').length);
    }
}


// ── Close dropdown on outside click ──────────────────────────────────────────
$(document).on('click', function (e) {
    if (!$(e.target).closest('.dl-worker-search-wrap, .edl-worker-search-wrap').length) {
        $('.dl-user-dropdown, .edl-user-dropdown').addClass('hidden');
    }
});

// ── Remove chip ───────────────────────────────────────────────────────────────
$(document).on('click', '.dl-remove-chip', function () {
    const $chip = $(this).closest('.user-chip');
    const $container = $chip.closest('.dl-workers-container, .edl-workers-container');
    const prefix = $container.hasClass('dl-workers-container') ? 'dl' : 'edl';
    const id = $chip.data('user-id');
    _dlRemoveWorkerChip($container, id, prefix);
});

